import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import Select from "react-select";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import "../componentCss/webform.css";
import { useNavigate } from "react-router-dom";
import Dashboardheader from "./dashboardheader";
import Sidebar from "./sidebar";
import "../componentCss/sidebar.css";
import { BsFillTrash3Fill, BsFilePlusFill } from "react-icons/bs";
import { MdVisibility, MdDragIndicator } from "react-icons/md";
import MasterDataPreviewModal from "./ModalComponents/MasterDataPreviewModal";
import masterDataService from "../../services/masterDataService";
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy, useSortable, arrayMove } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import {
  saveWebFormAction,
  getFormListAction,
  getFieldTypeAction,
  getDepartmentAction,
  getFormTypeListAction,
  getFormDetailsAction,
  getCategoryListForWebFormAction,
  getMasterListAction,
  getMasterTableColumnAction,
  getFoldersAction,
} from "../../Action/modernAdminActions";
import { useMigrationHelper } from "../../utils/migrationHelper";
import toast, { Toaster } from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css";
import { BsArrowLeftCircleFill } from "react-icons/bs";
import config from "../../config/config";
import { Link } from "react-router-dom";
import { decryptData } from "./decrypt";
import {
  evaluateFormula,
  parseFormulaFields,
  validateFormulaSyntax,
  detectCircularDependency
} from "../../utils/formulaBuilder";
let fieldArr = [];
let radioFieldValueArr = [];
let radioAddFieldArr = [[{ radioCheckboxValue: "" }]];

// ImageOptionPreview component for displaying image options with expand/collapse functionality
const ImageOptionPreview = ({ imageUrl, label }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="position-relative d-inline-block ms-2">
      <img
        src={imageUrl}
        alt={label}
        onClick={() => setExpanded(!expanded)}
        style={{
          width: expanded ? '300px' : '50px',
          height: expanded ? 'auto' : '50px',
          objectFit: 'cover',
          borderRadius: '4px',
          border: '2px solid #0d6efd',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          boxShadow: expanded ? '0 4px 8px rgba(0,0,0,0.2)' : 'none',
          zIndex: expanded ? 1000 : 1,
          position: expanded ? 'absolute' : 'static',
          left: expanded ? 0 : 'auto',
          top: expanded ? 0 : 'auto'
        }}
      />
      {expanded && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100"
          style={{
            backgroundColor: 'rgba(0,0,0,0.3)',
            zIndex: 999
          }}
          onClick={() => setExpanded(false)}
        />
      )}
    </div>
  );
};

// Field Configuration Map for dynamic field type management with validation
const FIELD_CONFIG_MAP = {
  text: {
    controls: ['placeholder', 'required', 'min_length', 'max_length', 'default', 'validation'],
    defaults: {
      field_type: 'text',
      options: [],
      placeholder: '',
      required: false,
      validation: {
        required_message: 'This field is required',
        min_length_message: 'Text is too short',
        max_length_message: 'Text is too long',
        pattern: '',
        pattern_message: 'Please enter a valid format'
      }
    },
    needsOptions: false,
    inputType: 'text'
  },
  textarea: {
    controls: ['placeholder', 'required', 'min_length', 'max_length', 'default', 'validation'],
    defaults: {
      field_type: 'textarea',
      options: [],
      placeholder: '',
      required: false,
      validation: {
        required_message: 'This field is required',
        min_length_message: 'Text is too short',
        max_length_message: 'Text is too long'
      }
    },
    needsOptions: false,
    inputType: 'textarea'
  },
  number: {
    controls: ['min_value', 'max_value', 'step', 'required', 'default', 'validation'],
    defaults: {
      field_type: 'number',
      options: [],
      min_value: null,
      max_value: null,
      required: false,
      validation: {
        required_message: 'This field is required',
        min_value_message: 'Number is too small',
        max_value_message: 'Number is too large',
        invalid_number_message: 'Please enter a valid number',
        pattern: '',
        pattern_message: 'Please enter a valid number format'
      }
    },
    needsOptions: false,
    inputType: 'number'
  },
  email: {
    controls: ['placeholder', 'required', 'default', 'validation'],
    defaults: {
      field_type: 'email',
      options: [],
      placeholder: '',
      required: false,
      validation: {
        required_message: 'This field is required',
        invalid_email_message: 'Please enter a valid email address'
      }
    },
    needsOptions: false,
    inputType: 'email'
  },
  phone: {
    controls: ['placeholder', 'required', 'default', 'validation'],
    defaults: {
      field_type: 'phone',
      options: [],
      placeholder: '',
      required: false,
      validation: {
        required_message: 'This field is required',
        invalid_phone_message: 'Please enter a valid phone number',
        pattern: '',
        pattern_message: 'Please enter a valid phone format'
      }
    },
    needsOptions: false,
    inputType: 'tel'
  },
  url: {
    controls: ['placeholder', 'required', 'default', 'validation'],
    defaults: {
      field_type: 'url',
      options: [],
      placeholder: '',
      required: false,
      validation: {
        required_message: 'This field is required',
        invalid_url_message: 'Please enter a valid URL'
      }
    },
    needsOptions: false,
    inputType: 'url'
  },
  date: {
    controls: ['min_value', 'max_value', 'required', 'default', 'validation'],
    defaults: {
      field_type: 'date',
      options: [],
      min_value: null,
      max_value: null,
      required: false,
      validation: {
        required_message: 'This field is required',
        min_date_message: 'Date is too early',
        max_date_message: 'Date is too late',
        invalid_date_message: 'Please enter a valid date'
      }
    },
    needsOptions: false,
    inputType: 'date'
  },
  time: {
    controls: ['min_value', 'max_value', 'required', 'default', 'validation'],
    defaults: {
      field_type: 'time',
      options: [],
      required: false,
      validation: {
        required_message: 'This field is required',
        min_time_message: 'Time is too early',
        max_time_message: 'Time is too late',
        invalid_time_message: 'Please enter a valid time'
      }
    },
    needsOptions: false,
    inputType: 'time'
  },
  datetime: {
    controls: ['min_value', 'max_value', 'required', 'default', 'validation'],
    defaults: {
      field_type: 'datetime',
      options: [],
      required: false,
      validation: {
        required_message: 'This field is required',
        min_datetime_message: 'Date and time is too early',
        max_datetime_message: 'Date and time is too late',
        invalid_datetime_message: 'Please enter a valid date and time'
      }
    },
    needsOptions: false,
    inputType: 'datetime-local'
  },
  dropdown: {
    controls: ['options', 'allowOther', 'default', 'required', 'validation'],
    defaults: {
      field_type: 'dropdown',
      options: [{ label: 'Option 1', value: 'option1', imageUrl: null }],
      allowOther: false,
      required: false,
      validation: {
        required_message: 'Please select an option'
      }
    },
    needsOptions: true,
    inputType: 'select'
  },
  select_manual: {
    controls: ['options', 'allowOther', 'default', 'required', 'validation'],
    defaults: {
      field_type: 'select_manual',
      options: [{ label: 'Option 1', value: 'option1', imageUrl: null }],
      allowOther: false,
      required: false,
      validation: {
        required_message: 'Please select an option'
      }
    },
    needsOptions: true,
    inputType: 'select'
  },
  multiselect: {
    controls: ['options', 'allowOther', 'default', 'required', 'validation'],
    defaults: {
      field_type: 'multiselect',
      options: [{ label: 'Option 1', value: 'option1', imageUrl: null }],
      allowOther: false,
      required: false,
      validation: {
        required_message: 'Please select at least one option'
      }
    },
    needsOptions: true,
    inputType: 'multiselect'
  },
  radio: {
    controls: ['options', 'layout', 'default', 'required', 'validation'],
    defaults: {
      field_type: 'radio',
      options: [{ label: 'Option 1', value: 'option1', imageUrl: null }],
      layout: 'column',
      required: false,
      validation: {
        required_message: 'Please select an option'
      }
    },
    needsOptions: true,
    inputType: 'radio'
  },
  checkbox: {
    controls: ['options', 'layout', 'default', 'required', 'validation'],
    defaults: {
      field_type: 'checkbox',
      options: [{ label: 'Option 1', value: 'option1', imageUrl: null }],
      layout: 'column',
      required: false,
      validation: {
        required_message: 'Please select at least one option'
      }
    },
    needsOptions: true,
    inputType: 'checkbox'
  },
  checkboxes: {
    controls: ['options', 'layout', 'default', 'required', 'validation'],
    defaults: {
      field_type: 'checkboxes',
      options: [{ label: 'Option 1', value: 'option1', imageUrl: null }],
      layout: 'column',
      required: false,
      validation: {
        required_message: 'Please select at least one option'
      }
    },
    needsOptions: true,
    inputType: 'checkbox'
  },
  toggle: {
    controls: ['labelOn', 'labelOff', 'default', 'required', 'validation'],
    defaults: {
      field_type: 'toggle',
      options: [],
      labelOn: 'Yes',
      labelOff: 'No',
      required: false,
      validation: {
        required_message: 'Please make a selection'
      }
    },
    needsOptions: false,
    inputType: 'checkbox'
  },
  file: {
    controls: ['accept', 'maxSize', 'maxQuantity', 'required', 'validation'],
    defaults: {
      field_type: 'file',
      options: [],
      accept: '*/*',
      maxSize: 5,
      maxQuantity: 1,
      required: false,
      validation: {
        required_message: 'Please select a file',
        invalid_file_type_message: 'File type not allowed',
        file_too_large_message: 'File size exceeds limit',
        too_many_files_message: 'Too many files selected'
      }
    },
    needsOptions: false,
    inputType: 'file'
  },
  lookup: {
    controls: ['sourceKey', 'valueMapping', 'labelMapping', 'debounce', 'required', 'validation'],
    defaults: {
      field_type: 'lookup',
      options: [],
      sourceKey: '',
      valueMapping: '',
      labelMapping: '',
      debounce: 300,
      required: false,
      validation: {
        required_message: 'This field is required',
        no_results_message: 'No matching results found'
      }
    },
    needsOptions: false,
    inputType: 'text'
  },
  signature: {
    controls: ['required', 'validation'],
    defaults: {
      field_type: 'signature',
      options: [],
      required: false,
      validation: {
        required_message: 'Please provide your signature'
      }
    },
    needsOptions: false,
    inputType: 'signature'
  },
  header: {
    controls: [],
    defaults: {
      field_type: 'header',
      options: [],
      required: false
    },
    needsOptions: false,
    inputType: 'header'
  },
  markdown: {
    controls: ['markdown_editor'],
    defaults: {
      field_type: 'markdown',
      label: '# Heading\n\nYour **markdown** content here...',
      help_text: '',
      options: [],
      required: false
    },
    needsOptions: false,
    inputType: 'markdown'
  },
  file_upload: {
    controls: ['accept', 'maxSize', 'maxQuantity', 'required', 'validation'],
    defaults: {
      field_type: 'file_upload',
      options: [],
      accept: '*/*',
      maxSize: 5,
      maxQuantity: 1,
      required: false,
      validation: {
        required_message: 'Please select a file',
        invalid_file_type_message: 'File type not allowed',
        file_too_large_message: 'File size exceeds limit',
        too_many_files_message: 'Too many files selected'
      }
    },
    needsOptions: false,
    inputType: 'file'
  },
  formula: {
    controls: ['formula_builder', 'decimal_places', 'prefix', 'suffix', 'show_formula', 'validation'],
    defaults: {
      field_type: 'formula',
      options: [],
      formula_expression: '',
      referenced_field_ids: [],
      decimal_places: 2,
      prefix: '',
      suffix: '',
      show_formula: false,
      read_only: true,
      required: false,
      calculated_value: null,
      formula_error: null,
      validation: {
        invalid_formula_message: 'Formula contains errors',
        missing_field_message: 'Referenced field does not exist',
        division_by_zero_message: 'Division by zero error'
      }
    },
    needsOptions: false,
    inputType: 'formula'
  }
};

// Helper function to generate unique field IDs
const generateFieldId = (label, existingFields) => {
  if (!label) return '';

  let baseId = label.toLowerCase()
    .replace(/[^a-z0-9\s]/g, '') // Remove special characters
    .replace(/\s+/g, '_') // Replace spaces with underscores
    .substring(0, 50); // Limit length

  // Ensure uniqueness
  let counter = 1;
  let fieldId = baseId;
  while (existingFields.some(field => field.id === fieldId || field.name === fieldId)) {
    fieldId = `${baseId}_${counter}`;
    counter++;
  }

  return fieldId;
};

// Helper function to generate stable option values
const generateOptionValue = (label) => {
  if (!label) return '';
  return label.toLowerCase()
    .replace(/[^a-z0-9\s]/g, '')
    .replace(/\s+/g, '_')
    .substring(0, 30);
};

// Function to validate all fields for submission
const validateAllFields = (fields) => {
    const allErrors = {};
    let hasErrors = false;

    fields.forEach((field, index) => {
        const fieldErrors = validateField(field, index, true); // Use submission validation
        if (Object.keys(fieldErrors).length > 0) {
            allErrors[index] = fieldErrors;
            hasErrors = true;
        }
    });

    return { errors: allErrors, hasErrors };
};

// Field validation function
const validateField = (field, index, isSubmissionValidation = false) => {
  const errors = {};

  // For real-time validation, only validate if field has been edited
  // For submission validation, validate all fields regardless of edit status
  const hasBeenEdited = (field.label && field.label.trim() !== '') || (field.field_type && field.field_type !== '');

  if (!isSubmissionValidation && !hasBeenEdited) {
    return errors; // Don't validate empty/untouched fields during real-time validation
  }

  // Always validate required fields during submission, even if empty
  if (!field.label || field.label.trim() === '') {
    errors.label = 'Field label is required';
  }

  // Check multiple field type properties to ensure proper validation
  const hasValidFieldType = field.field_type && field.field_type !== '' &&
                           field.fieldtypeId && field.fieldtypeId !== '';

  if (!hasValidFieldType) {
    errors.field_type = 'Field type is required';
  }

  const config = FIELD_CONFIG_MAP[field.field_type];
  if (config && config.needsOptions && field.field_type) {
    if (!field.options || field.options.length === 0) {
      errors.options = 'At least one option is required for this field type';
    } else {
      // Check for empty options
      const emptyOptions = field.options.filter(opt => !opt.label || opt.label.trim() === '');
      if (emptyOptions.length > 0) {
        errors.options = 'All options must have labels';
      }

      // Check for duplicate option values
      const values = field.options.map(opt => opt.value).filter(Boolean);
      const uniqueValues = [...new Set(values)];
      if (values.length !== uniqueValues.length && values.length > 0) {
        errors.options = 'Option values must be unique';
      }
    }
  }

  return errors;
};

// Sortable Field Item Component for drag & drop
const SortableFieldItem = ({ id, children }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    cursor: isDragging ? 'grabbing' : 'default'
  };

  const dragHandleProps = { ...attributes, ...listeners };

  return (
    <div ref={setNodeRef} style={style}>
      {/* Pass drag handle props to children as a function */}
      {typeof children === 'function' ? children(dragHandleProps) : children}
    </div>
  );
};

const Webform = () => {
  const navigate = useNavigate();
  const { useModernAPI } = useMigrationHelper();
  const [formData, setForm] = useState({
    name: "",  // Changed from formName
    description: "",  // Added
    department_id: "",  // Changed from departmentId
    category_id: "",  // Changed from formCategory
    folder_id: "",  // Added for folder selection
    is_active: true,  // Added
    version: "1"  // Added
  });
  const [formNumber, setformNumber] = useState(
    Math.floor(Math.random() * 1000000000)
  );
  const [formValues, setFormValues] = useState([
    {
      field_id: "",
      id: generateFieldId("Field 1", []),
      name: generateFieldId("Field 1", []),
      label: "Field 1",
      field_type: "",
      required: false,
      placeholder: "",
      help_text: "",
      options: [],
      min_length: null,
      max_length: null,
      min_value: null,
      max_value: null,
      order: 0,
      default: null,
      // Validation configuration
      validation: {
        required_message: 'This field is required',
        min_length_message: 'Text is too short',
        max_length_message: 'Text is too long',
        pattern: '',
        pattern_message: 'Please enter a valid format'
      },
      // Additional field type specific properties
      allowOther: false,
      layout: 'column',
      labelOn: 'Yes',
      labelOff: 'No',
      accept: '*/*',
      maxSize: 5,
      maxQuantity: 1,
      sourceKey: '',
      valueMapping: '',
      labelMapping: '',
      debounce: 300,
      // Frontend compatibility fields
      field_name: "Field 1",
      fieldName: "Field 1",
      fieldtype: "",
      fieldtypeId: "",
      is_mandatory: false,
      isMandatory: false,
      is_add_more: 0,
      isAddMore: 0,
      field_description: "",
      form_type: "",
      formType: "",
      dropdown_form_id: "",
      dropdown_field_id: "",
      master_data_table: "",
      master_data_column: "",
      selected_form_id: "",
      selected_other_fields: [],
      otherFormFields: []
    },
  ]);
  const [formRadioCheckbox, setFormRadioCheckbox] = useState([
    { radioCheckboxValue: "" },
  ]);
  const [formfieldsList, setFormfieldsList] = useState([]);
  const [formFieldTypeList, setFormFieldTypeList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [formCategoryList, setFormCategoryList] = useState([]);
  const [formTypeList, setFormTypeList] = useState([]);
  const [formList, setFormList] = useState([]);
  const [folderList, setFolderList] = useState([]);
  const [rowIndex, setRowIndex] = useState(0);
  const [masterList, setMasterData] = useState([]);
  const [columDataList, setColumDataList] = useState([]);
  const [selectedFormFields, setSelectedFormFields] = useState({});
  const [fieldErrors, setFieldErrors] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  // Master Data Integration State
  const [masterDataTables, setMasterDataTables] = useState([]);
  const [masterDataColumns, setMasterDataColumns] = useState({});
  const [previewModalData, setPreviewModalData] = useState({
    visible: false,
    fieldLabel: '',
    options: [],
    tableName: '',
    columnName: ''
  });

  // Drag & drop sensors configuration
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8, // 8px movement required before drag starts
      },
    })
  );

  useEffect(() => {
    getFieldTypeAPI();
    getDepartmentAPI();
    getFormListAPI();
    getFormCategoryAPI();
    getFolderListAPI();
    getMasterList();
    fetchMasterDataTables(); // Load master data tables for dropdown configuration
  }, []);
  let getMasterList = async () => {
    let res = await getMasterListAction();
    setIsLoading(false);
    if (res.success) {
      // Handle both modern (plain data) and legacy (encrypted data) formats
      const data = res.data;
      if (Array.isArray(data)) {
        // Modern format - data is already decrypted
        setMasterData(data);
      } else if (data && Array.isArray(data.items)) {
        // Modern paginated format
        setMasterData(data.items);
      } else if (typeof data === "string") {
        // Legacy format - data needs decryption
        setMasterData(decryptData(data));
      } else {
        // Fallback - ensure we always set an array
        setMasterData(Array.isArray(data) ? data : []);
      }
    } else {
      setMasterData([]);
    }
  };

  // =========================================================================
  // MASTER DATA INTEGRATION FUNCTIONS
  // =========================================================================

  // Fetch available master data tables for dropdown configuration
  const fetchMasterDataTables = async () => {
    try {
      const response = await getMasterListAction({ page: 1, page_size: 1000 });

      if (response && response.data) {
        // Handle nested response structure from backend
        // Backend returns: { message, data: { tables: [...], total, page, ... } }
        const tablesData = response.data?.data?.tables || response.data?.tables || response.data || [];

        console.log('📊 RAW BACKEND RESPONSE:', response);
        console.log('📊 TABLES DATA:', tablesData);

        const tables = tablesData.map(table => {
          console.log('📋 Processing table:', {
            table_id: table.table_id,
            name: table.name,
            display_name: table.display_name,
            raw: table
          });
          return {
            value: table.table_id,
            label: table.display_name || table.name || table.table_id,
            category: table.category,
            totalRecords: table.total_records
          };
        });

        console.log('📋 FINAL DROPDOWN OPTIONS:', tables);
        setMasterDataTables(tables);
      }
    } catch (error) {
      console.error('Error fetching master data tables:', error);
      toast.error('Failed to load master data tables');
    }
  };

  // Fetch columns for a specific table
  const fetchMasterDataColumns = async (tableId) => {
    console.log('📡 fetchMasterDataColumns called with tableId:', tableId);

    try {
      console.log('🌐 Making API call to getMasterTableColumnAction...');
      const response = await getMasterTableColumnAction({ name: tableId });

      console.log('📥 API Response received:', response);
      console.log('📊 Response structure check:', {
        hasResponse: !!response,
        hasData: !!(response && response.data),
        hasColumns: !!(response && response.data && response.data.columns),
        columnsCount: response?.data?.columns?.length || 0
      });

      if (response && response.data && response.data.columns) {
        console.log('✅ Columns found:', response.data.columns.length);

        const columns = response.data.columns.map(col => ({
          value: col.column_id,
          label: col.display_name || col.column_id,
          dataType: col.data_type
        }));

        console.log('🎯 Mapped columns:', columns);

        setMasterDataColumns(prev => {
          const updated = {
            ...prev,
            [tableId]: columns
          };
          console.log('🔄 masterDataColumns state updated:', updated);
          return updated;
        });

        console.log('💾 State updated for table:', tableId);
      } else {
        console.warn('⚠️ Response does not have expected structure:', response);
      }
    } catch (error) {
      console.error('❌ Error fetching table columns:', error);
      console.error('❌ Error details:', {
        message: error.message,
        stack: error.stack,
        response: error.response
      });
      toast.error('Failed to load table columns');
    }
  };

  // Fetch preview count of options
  const fetchMasterDataPreviewCount = async (tableId, columnId, fieldIndex) => {
    try {
      const response = await masterDataService.getColumnOptions(tableId, columnId);

      const updatedFormValues = [...formValues];
      updatedFormValues[fieldIndex].masterDataPreviewCount = response.data?.length || 0;

      setFormValues(updatedFormValues);
    } catch (error) {
      console.error('Error fetching preview count:', error);
    }
  };

  // Preview master data options in modal
  const previewMasterDataOptions = async (fieldIndex) => {
    const field = formValues[fieldIndex];

    if (!field.master_data_table || !field.master_data_column) {
      return;
    }

    try {
      const response = await masterDataService.getColumnOptions(
        field.master_data_table,
        field.master_data_column
      );

      // Find table name
      const table = masterDataTables.find(t => t.value === field.master_data_table);

      // Backend returns: { success, message, data: { options, total, limit, offset } }
      // response.data contains the backend response
      const options = response.data?.data?.options || response.data?.options || [];

      setPreviewModalData({
        visible: true,
        fieldLabel: field.label,
        options: options,
        tableName: table?.label || field.master_data_table,
        columnName: field.master_data_column
      });
    } catch (error) {
      console.error('Error loading preview:', error);
      toast.error('Failed to load options preview');
    }
  };

  // Toggle master data mode for a field
  const toggleMasterData = (e, fieldIndex) => {
    const checked = e.target.checked;
    const updatedFormValues = [...formValues];
    const field = updatedFormValues[fieldIndex];

    field.useMasterData = checked;

    if (checked) {
      // Clear static options when switching to master data
      field.options = [];
    } else {
      // Clear master data references when switching to static
      field.master_data_table = "";
      field.master_data_column = "";
    }

    setFormValues(updatedFormValues);
  };

  // Handle master table selection
  const handleMasterTableChange = async (selected, fieldIndex) => {
    console.log('🔍 handleMasterTableChange called:', { selected, fieldIndex });
    console.log('🎯 USER SELECTED:', selected);
    console.log('🎯 TABLE ID BEING USED:', selected?.value);

    const updatedFormValues = [...formValues];
    const field = updatedFormValues[fieldIndex];

    field.master_data_table = selected ? selected.value : "";
    field.master_data_column = ""; // Reset column when table changes

    setFormValues(updatedFormValues);

    // Fetch columns for selected table
    if (selected) {
      console.log('✅ Calling fetchMasterDataColumns with tableId:', selected.value);
      await fetchMasterDataColumns(selected.value);
    } else {
      console.log('❌ No table selected, skipping column fetch');
    }
  };

  // Handle master column selection
  const handleMasterColumnChange = async (selected, fieldIndex) => {
    const updatedFormValues = [...formValues];
    const field = updatedFormValues[fieldIndex];

    field.master_data_column = selected ? selected.value : "";

    setFormValues(updatedFormValues);

    // Fetch preview count
    if (selected && field.master_data_table) {
      await fetchMasterDataPreviewCount(field.master_data_table, selected.value, fieldIndex);
    }
  };

  let handleChangeTable = (index, e) => {
    const { name, value } = e.target;

    // Update the form values based on index
    setFormValues((prev) =>
      prev.map((item, idx) =>
        idx === index ? { ...item, [name]: value } : item
      )
    );

    // Call the master list retrieval function with the selected value
    getMasterListForName(index, value);
  };

  const handleChangeData = (index, e) => {
    const { name, value } = e.target;

    setFormValues((prev) =>
      prev.map((item, idx) =>
        idx === index ? { ...item, [name]: value } : item
      )
    );
  };

  let getMasterListForName = async (index, id) => {
    let res = await getMasterListAction();
    setIsLoading(false);

    if (res.success) {
      // Handle both modern (plain data) and legacy (encrypted data) formats
      let data;
      if (Array.isArray(res.data)) {
        // Modern format - data is already decrypted
        data = res.data;
      } else if (res.data && Array.isArray(res.data.items)) {
        // Modern paginated format
        data = res.data.items;
      } else if (typeof res.data === "string") {
        // Legacy format - data needs decryption
        data = decryptData(res.data);
      } else {
        // Fallback - try to use data as-is
        data = res.data || [];
      }

      // Filter the data based on the provided ID
      let filterData = data.filter((item) => item.id == id);

      // Fetch related form data for the corresponding dbTable
      if (filterData.length > 0) {
        getFormDataListAPI(filterData[0].dbTable, index);
      }
    }
  };

  let getFormDataListAPI = async (value, index) => {
    setIsLoading(true);
    try {
      let res = await getMasterTableColumnAction({ name: value });
      setIsLoading(false);

      if (res?.success) {
        let columnData;
        // Handle different response formats
        if (Array.isArray(res.data)) {
          columnData = res.data;
        } else if (res.data && Array.isArray(res.data.items)) {
          columnData = res.data.items;
        } else if (typeof res.data === "string") {
          columnData = decryptData(res.data);
        } else if (res.data && res.data.column) {
          // Direct column data
          columnData = res.data;
        } else {
          columnData = res.data || {};
        }

        setFormValues((prev) =>
          prev.map((item, idx) =>
            idx === index ? { ...item, columDataList: columnData } : item
          )
        );
      } else {
        setColumDataList([]);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching master table columns:", error);
    }
  };
  let getFormFieldsListAPI = async (index, formId) => {
    let res = await getFormDetailsAction({ id: formId });
    if (res.success) {
      let formData = res.data;
      // Handle different response formats
      if (typeof formData === "string") {
        formData = decryptData(formData);
      }

      fieldArr[index] = formData;
      setFormfieldsList(formData);
    }
  };

  let getOtherFormFieldsAPI = async (index, formId) => {
    let res = await getFormDetailsAction({ id: formId });
    if (res.success) {
      let formData = res.data;
      // Handle different response formats
      if (typeof formData === "string") {
        formData = decryptData(formData);
      }

      // Extract fields from the form structure
      const fields = formData?.fields || [];

      setFormValues((prev) =>
        prev.map((item, idx) =>
          idx === index ? { ...item, otherFormFields: fields, selected_form_id: formId } : item
        )
      );
    }
  };
  let getFormListAPI = async () => {
    let res = await getFormListAction();
    if (res.success) {
      let formData = res.data;
      // Handle different response formats
      if (Array.isArray(formData)) {
        setFormList(formData);
      } else if (formData && Array.isArray(formData.items)) {
        // Modern paginated format
        setFormList(formData.items);
      } else if (typeof formData === "string") {
        // Legacy format - data needs decryption
        const decryptedData = decryptData(formData);
        setFormList(Array.isArray(decryptedData) ? decryptedData : []);
      } else {
        // Fallback - ensure we always set an array
        setFormList(Array.isArray(formData) ? formData : []);
      }
    } else {
      setFormList([]);
    }
  };
  let getDepartmentAPI = async () => {
    let res = await getDepartmentAction();
    if (res.success && res.data) {
      if (Array.isArray(res.data)) {
        const departments = res.data.map(dept => {
          const depId = dept._id || dept.id || dept.department_id;
          return {
            ...dept,
            id: depId,
            department_id: depId,
            _id: depId
          };
        });
        setDepartmentList(departments);
      } else if (res.data.items && Array.isArray(res.data.items)) {
        const departments = res.data.items.map(dept => {
          const depId = dept._id || dept.id || dept.department_id;
          return {
            ...dept,
            id: depId,
            department_id: depId,
            _id: depId
          };
        });
        setDepartmentList(departments);
      } else {
        setDepartmentList([]);
      }
    } else {
      setDepartmentList([]);
    }
  };
  let getFormCategoryAPI = async () => {
    let res = await getCategoryListForWebFormAction();
    if (res.success && res.data) {
      if (Array.isArray(res.data)) {
        // Transform category data to include both ID formats
        const categories = res.data.map(cat => ({
          ...cat,
          id: cat.category_id || cat._id, // Keep integer ID for frontend compatibility
          category_id: cat.category_id || cat._id // Backend string ID
        }));
        setFormCategoryList(categories);
      } else if (res.data.items && Array.isArray(res.data.items)) {
        const categories = res.data.items.map(cat => ({
          ...cat,
          id: cat.category_id || cat._id,
          category_id: cat.category_id || cat._id
        }));
        setFormCategoryList(categories);
      } else {
        setFormCategoryList([]);
      }
    } else {
      setFormCategoryList([]);
    }
  };

  let getFolderListAPI = async () => {
    let res = await getFoldersAction();
    if (res.success && res.data) {
      if (Array.isArray(res.data)) {
        const folders = res.data.map(folder => ({
          ...folder,
          id: folder.folder_id || folder._id,
          folder_id: folder.folder_id || folder._id
        }));
        setFolderList(folders);
      } else if (res.data.items && Array.isArray(res.data.items)) {
        const folders = res.data.items.map(folder => ({
          ...folder,
          id: folder.folder_id || folder._id,
          folder_id: folder.folder_id || folder._id
        }));
        setFolderList(folders);
      } else {
        setFolderList([]);
      }
    } else {
      setFolderList([]);
    }
  };
  let getFormTypeListAPI = async (id) => {
    let res = await getFormTypeListAction({ departmentId: id });
    if (res.success) {
      // Handle both modern (plain data) and legacy (encrypted data) formats
      const data = res.data;
      if (Array.isArray(data)) {
        // Modern format - data is already decrypted
        setFormTypeList(data);
      } else if (typeof data === "string") {
        // Legacy format - data needs decryption
        setFormTypeList(decryptData(data));
      } else {
        // Fallback - try to use data as-is
        setFormTypeList(data || []);
      }
    } else {
      setFormTypeList([]);
    }
  };

  let getFieldTypeAPI = async () => {
    let res = await getFieldTypeAction();
    let fieldTypes = [];

    if (res.success) {
      // Handle both modern (plain data) and legacy (encrypted data) formats
      const data = res.data;
      if (Array.isArray(data)) {
        // Modern format - data is already decrypted
        fieldTypes = data;
      } else if (data && Array.isArray(data.items)) {
        // Modern paginated format
        fieldTypes = data.items;
      } else if (typeof data === "string") {
        // Legacy format - data needs decryption
        const decryptedData = decryptData(data);
        fieldTypes = Array.isArray(decryptedData) ? decryptedData : [];
      } else {
        // Fallback - ensure we always set an array
        fieldTypes = Array.isArray(data) ? data : [];
      }
    }

    // Add formula field type if not already present (frontend-only field type)
    const hasFormula = fieldTypes.some(f =>
      f.fieldType === 'formula' ||
      f.name === 'Formula' ||
      f.name === 'formula'
    );

    if (!hasFormula) {
      fieldTypes.push({
        id: 'formula_field_type',  // Unique ID for formula field type
        name: 'Formula',            // Display name in dropdown
        fieldType: 'formula'        // Maps to FIELD_CONFIG_MAP key
      });
    }

    setFormFieldTypeList(fieldTypes.length > 0 ? fieldTypes : []);
  };

  // Handle drag & drop reordering of fields
  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (!over || active.id === over.id) {
      return;
    }

    setFormValues((fields) => {
      // Find indices in the array
      const oldIndex = fields.findIndex(f => f.id === active.id);
      const newIndex = fields.findIndex(f => f.id === over.id);

      if (oldIndex === -1 || newIndex === -1) {
        return fields;
      }

      // Reorder fields
      const reorderedFields = arrayMove(fields, oldIndex, newIndex);

      // Update order property for all fields
      const updatedFields = reorderedFields.map((field, index) => ({
        ...field,
        order: index
      }));

      return updatedFields;
    });

    toast.success('Field order updated');
  };

  let handleChangeForm = (e) => {
    let { name, value } = e.target;
    setForm((old) => {
      return { ...old, [name]: value };
    });
  };
  const handleChange = useCallback((i, e) => {
    const { name, value, type, checked } = e.target;

    if (name == "formId") {
      getFormFieldsListAPI(i, value);
    }
    if (name == "otherFormId") {
      getOtherFormFieldsAPI(i, value);
    }

    setFormValues(prevValues => {
      const newFormValues = [...prevValues];

      // Handle field type changes with reactive UI updates
      if (name == "field_type") {
        // Handle empty selection (Choose type...)
        if (!value || value === '') {
          newFormValues[i]["field_type"] = '';
          newFormValues[i]["fieldtypeId"] = '';
          newFormValues[i]["fieldtype"] = '';
        } else {
          let fieldTypeValue = formFieldTypeList.find((element) => {
            return element.id == value;
          });

          const actualFieldType = fieldTypeValue ? (fieldTypeValue.fieldType || fieldTypeValue.name) : value;
          const config = FIELD_CONFIG_MAP[actualFieldType];

          if (config) {
            // Preserve shared properties and apply new defaults
            const sharedProps = {
              label: newFormValues[i].label,
              id: newFormValues[i].id,
              name: newFormValues[i].name,
              order: newFormValues[i].order,
              help_text: newFormValues[i].help_text,
              required: newFormValues[i].required
            };

            // Merge existing validation with new defaults, preserving custom messages
            const existingValidation = newFormValues[i].validation || {};
            const newValidation = { ...config.defaults.validation };

            // Only use new default messages for empty or default validation messages
            Object.keys(newValidation).forEach(key => {
              if (existingValidation[key] && existingValidation[key] !== '') {
                // Keep existing custom validation message
                newValidation[key] = existingValidation[key];
              }
            });

            // Deep clone config.defaults to avoid shared references (especially for options array)
            const clonedDefaults = JSON.parse(JSON.stringify(config.defaults));

            newFormValues[i] = {
              ...newFormValues[i],
              ...clonedDefaults,
              ...sharedProps,
              validation: newValidation,
              fieldtypeId: value,
              fieldtype: actualFieldType,
              field_type: actualFieldType
            };
          } else {
            newFormValues[i]["field_type"] = actualFieldType;
            newFormValues[i]["fieldtypeId"] = value;
            newFormValues[i]["fieldtype"] = actualFieldType;
          }
        }

        // Clear field-specific errors when type changes
        setFieldErrors(prev => {
          const newErrors = { ...prev };
          delete newErrors[i];
          return newErrors;
        });
      } else if (name == "label") {
        // Update label without regenerating ID (to prevent focus loss)
        // ID regeneration happens on blur instead
        newFormValues[i][name] = value;
        newFormValues[i].field_name = value; // Legacy compatibility
      } else if (type === "checkbox") {
        newFormValues[i][name] = checked;
        if (name === "required") {
          newFormValues[i].is_mandatory = checked ? 1 : 0; // Legacy compatibility
          newFormValues[i].isMandatory = checked ? 1 : 0; // Legacy compatibility
        }
      } else if (name.startsWith("validation.")) {
        // Handle validation message updates
        const validationKey = name.replace("validation.", "");
        if (!newFormValues[i].validation) {
          newFormValues[i].validation = {};
        }
        newFormValues[i].validation[validationKey] = value;
      } else {
        newFormValues[i][name] = value;
        // Update legacy compatibility fields
        if (name === "field_type") {
          newFormValues[i]["fieldtype"] = value;
        }
      }

      // Validate field and update errors (only if field has content)
      const fieldErrors = validateField(newFormValues[i], i);
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        if (Object.keys(fieldErrors).length > 0) {
          newErrors[i] = fieldErrors;
        } else {
          delete newErrors[i]; // Remove errors if field is now valid
        }
        return newErrors;
      });

      // Recalculate formulas that depend on changed field
      if ((name === 'default' || name === 'field_type') && newFormValues[i].field_type === 'number') {
        newFormValues.forEach((field, idx) => {
          if (field.field_type === 'formula' &&
              field.referenced_field_ids?.includes(newFormValues[i].id)) {
            calculateFormulaPreview(idx, newFormValues);
          }
        });
      }

      return newFormValues;
    });
  }, [formFieldTypeList, getFormFieldsListAPI, getOtherFormFieldsAPI]);

  // Handle label blur - regenerate ID/name when user finishes editing
  const handleLabelBlur = useCallback((i, e) => {
    const value = e.target.value;
    if (!value || !value.trim()) return;

    setFormValues(prevValues => {
      const newFormValues = [...prevValues];
      const newId = generateFieldId(value, newFormValues.filter((_, idx) => idx !== i));

      // Only update if ID actually changed (to avoid unnecessary re-renders)
      if (newFormValues[i].id !== newId) {
        newFormValues[i].id = newId;
        newFormValues[i].name = newId;
        return newFormValues;
      }
      return prevValues; // Return unchanged if no update needed
    });
  }, []);

  let handleChangeRadio = (i, e) => {
    let newFormValues = [...formValues];
    radioFieldValueArr[i] = e.target.value;
    newFormValues[rowIndex]["radioCheckbox"] = radioFieldValueArr;

    // Update backend options array
    const validOptions = radioFieldValueArr
      .filter(option => option && option.trim())
      .map(option => option.trim());
    newFormValues[rowIndex]["options"] = validOptions;

    setFormValues(newFormValues);
  };

  // Options management functions for choice fields
  const addOption = (fieldIndex) => {
    let newFormValues = [...formValues];
    const field = newFormValues[fieldIndex];

    if (!field.options) {
      field.options = [];
    }

    const newOptionNumber = field.options.length + 1;
    const newOption = {
      label: `Option ${newOptionNumber}`,
      value: generateOptionValue(`Option ${newOptionNumber}`),
      imageUrl: null
    };

    field.options.push(newOption);
    setFormValues(newFormValues);
  };

  const removeOption = (fieldIndex, optionIndex) => {
    let newFormValues = [...formValues];
    const field = newFormValues[fieldIndex];

    if (field.options && field.options.length > 1) { // Keep at least one option
      field.options.splice(optionIndex, 1);
      setFormValues(newFormValues);
    }
  };

  const updateOption = (fieldIndex, optionIndex, property, value) => {
    let newFormValues = [...formValues];
    const field = newFormValues[fieldIndex];

    if (field.options && field.options[optionIndex]) {
      field.options[optionIndex][property] = value;

      // Auto-generate value from label if value property is being updated and it's empty
      if (property === 'label' && (!field.options[optionIndex].value || field.options[optionIndex].value === '')) {
        field.options[optionIndex].value = generateOptionValue(value);
      }

      setFormValues(newFormValues);

      // Validate field after option update
      const fieldErrors = validateField(field, fieldIndex);
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        if (Object.keys(fieldErrors).length > 0) {
          newErrors[fieldIndex] = fieldErrors;
        } else {
          delete newErrors[fieldIndex];
        }
        return newErrors;
      });
    }
  };

  const moveOption = (fieldIndex, optionIndex, direction) => {
    let newFormValues = [...formValues];
    const field = newFormValues[fieldIndex];

    if (!field.options || field.options.length < 2) return;

    const newIndex = direction === 'up' ? optionIndex - 1 : optionIndex + 1;

    if (newIndex >= 0 && newIndex < field.options.length) {
      // Swap options
      const temp = field.options[optionIndex];
      field.options[optionIndex] = field.options[newIndex];
      field.options[newIndex] = temp;

      setFormValues(newFormValues);
    }
  };

  // Image upload handler for option images
  const uploadOptionImage = async (file, fieldIndex, optionIndex) => {
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    try {
      // TODO: Replace with actual upload API endpoint
      const response = await fetch(`${config.API_URL}/api/upload/image`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: formData
      });

      if (!response.ok) {
        throw new Error('Upload failed');
      }

      const data = await response.json();

      // Update option with image URL
      let newFormValues = [...formValues];
      if (newFormValues[fieldIndex].options[optionIndex]) {
        newFormValues[fieldIndex].options[optionIndex].imageUrl = data.url || data.imageUrl || URL.createObjectURL(file);
        setFormValues(newFormValues);
        toast.success('Image uploaded successfully');
      }
    } catch (error) {
      console.error('Image upload failed:', error);
      toast.error('Failed to upload image. Please try again.');
    }
  };

  const removeOptionImage = (fieldIndex, optionIndex) => {
    let newFormValues = [...formValues];
    if (newFormValues[fieldIndex].options[optionIndex]) {
      newFormValues[fieldIndex].options[optionIndex].imageUrl = null;
      setFormValues(newFormValues);
      toast.success('Image removed');
    }
  };

  let handleOtherFormFieldSelection = (fieldIndex, fieldId, isChecked) => {
    let newFormValues = [...formValues];
    if (!newFormValues[fieldIndex].selected_other_fields) {
      newFormValues[fieldIndex].selected_other_fields = [];
    }

    if (isChecked) {
      if (!newFormValues[fieldIndex].selected_other_fields.includes(fieldId)) {
        newFormValues[fieldIndex].selected_other_fields.push(fieldId);
      }
    } else {
      newFormValues[fieldIndex].selected_other_fields = newFormValues[fieldIndex].selected_other_fields.filter(id => id !== fieldId);
    }

    setFormValues(newFormValues);
  };

  let addFormFields = () => {
    fieldArr.push([]);
    radioFieldValueArr = [];
    radioAddFieldArr[rowIndex + 1] = [{ radioCheckboxValue: "" }];

    const newFieldNumber = formValues.length + 1;
    const newLabel = `Field ${newFieldNumber}`;
    const newField = {
      field_id: "",
      id: generateFieldId(newLabel, formValues),
      name: generateFieldId(newLabel, formValues),
      label: newLabel,
      field_type: "",
      required: false,
      placeholder: "",
      help_text: "",
      options: [],
      min_length: null,
      max_length: null,
      min_value: null,
      max_value: null,
      order: formValues.length,
      default: null,
      // Validation configuration
      validation: {
        required_message: 'This field is required',
        min_length_message: 'Text is too short',
        max_length_message: 'Text is too long',
        pattern: '',
        pattern_message: 'Please enter a valid format'
      },
      // Additional field type specific properties
      allowOther: false,
      layout: 'column',
      labelOn: 'Yes',
      labelOff: 'No',
      accept: '*/*',
      maxSize: 5,
      maxQuantity: 1,
      sourceKey: '',
      valueMapping: '',
      labelMapping: '',
      debounce: 300,
      // Frontend compatibility fields
      fieldtypeId: "",
      fieldtype: "",
      fieldName: newLabel,
      field_name: newLabel,
      is_mandatory: false,
      isMandatory: false,
      is_add_more: 0,
      isAddMore: 0,
      field_description: "",
      form_type: "",
      formType: "",
      dropdown_form_id: "",
      dropdown_field_id: "",
      master_data_table: "",
      master_data_column: "",
      selected_form_id: "",
      selected_other_fields: [],
      otherFormFields: []
    };

    setFormValues([...formValues, newField]);
    setRowIndex(rowIndex + 1);
  };

  // Formula field helper functions
  const insertFieldIntoFormula = (fieldIndex, fieldId) => {
    const newFormValues = [...formValues];
    const currentExpression = newFormValues[fieldIndex].formula_expression || '';
    const newExpression = currentExpression + (currentExpression ? ' ' : '') + fieldId;
    newFormValues[fieldIndex].formula_expression = newExpression;
    validateAndUpdateFormula(fieldIndex, newExpression, newFormValues);
    setFormValues(newFormValues);
  };

  const insertOperatorIntoFormula = (fieldIndex, operator) => {
    const newFormValues = [...formValues];
    const currentExpression = newFormValues[fieldIndex].formula_expression || '';
    const needsSpace = operator !== '(' && operator !== ')' && currentExpression.length > 0;
    const newExpression = currentExpression + (needsSpace ? ' ' : '') + operator + (needsSpace ? ' ' : '');
    newFormValues[fieldIndex].formula_expression = newExpression;
    validateAndUpdateFormula(fieldIndex, newExpression, newFormValues);
    setFormValues(newFormValues);
  };

  const handleFormulaChange = (fieldIndex, event) => {
    const newFormValues = [...formValues];
    const expression = event.target.value;
    newFormValues[fieldIndex].formula_expression = expression;
    validateAndUpdateFormula(fieldIndex, expression, newFormValues);
    setFormValues(newFormValues);
  };

  const validateAndUpdateFormula = (fieldIndex, expression, formValuesCopy) => {
    // Validate syntax
    const syntaxCheck = validateFormulaSyntax(expression);
    if (!syntaxCheck.valid) {
      formValuesCopy[fieldIndex].formula_error = syntaxCheck.error;
      formValuesCopy[fieldIndex].referenced_field_ids = [];
      formValuesCopy[fieldIndex].calculated_value = null;
      return;
    }

    // Parse referenced fields
    const referencedIds = parseFormulaFields(expression);

    // Validate that referenced fields exist and are number fields
    const validReferences = referencedIds.every(refId => {
      const field = formValuesCopy.find(f => f.id === refId);
      return field && field.field_type === 'number';
    });

    if (!validReferences) {
      formValuesCopy[fieldIndex].formula_error = 'One or more referenced fields do not exist or are not number fields';
      formValuesCopy[fieldIndex].referenced_field_ids = referencedIds;
      formValuesCopy[fieldIndex].calculated_value = null;
      return;
    }

    // Check for circular dependencies
    const allDependencies = {};
    formValuesCopy.forEach(field => {
      if (field.field_type === 'formula' && field.referenced_field_ids) {
        allDependencies[field.id] = field.referenced_field_ids;
      }
    });

    const hasCircular = detectCircularDependency(
      formValuesCopy[fieldIndex].id,
      referencedIds,
      allDependencies
    );

    if (hasCircular) {
      formValuesCopy[fieldIndex].formula_error = 'Circular dependency detected';
      formValuesCopy[fieldIndex].referenced_field_ids = referencedIds;
      formValuesCopy[fieldIndex].calculated_value = null;
      return;
    }

    // All validations passed
    formValuesCopy[fieldIndex].formula_error = null;
    formValuesCopy[fieldIndex].referenced_field_ids = referencedIds;

    // Try to calculate preview (if all referenced fields have default values)
    calculateFormulaPreview(fieldIndex, formValuesCopy);
  };

  const calculateFormulaPreview = (fieldIndex, formValuesCopy) => {
    const field = formValuesCopy[fieldIndex];

    if (!field.referenced_field_ids || field.referenced_field_ids.length === 0) {
      field.calculated_value = null;
      return;
    }

    // Build values map from default values
    const fieldValues = {};
    let hasAllDefaults = true;

    field.referenced_field_ids.forEach(refId => {
      const refField = formValuesCopy.find(f => f.id === refId);
      if (refField && refField.default !== null && refField.default !== undefined && refField.default !== '') {
        fieldValues[refId] = parseFloat(refField.default);
      } else {
        hasAllDefaults = false;
      }
    });

    if (hasAllDefaults && Object.keys(fieldValues).length > 0) {
      const result = evaluateFormula(field.formula_expression, fieldValues);
      if (result.success) {
        const decimalPlaces = field.decimal_places ?? 2;
        field.calculated_value = Number(result.value).toFixed(decimalPlaces);
      } else {
        field.calculated_value = null;
        field.formula_error = result.error;
      }
    } else {
      field.calculated_value = null;
    }
  };

  let removeFormFields = (i) => {
    // Check if any formulas reference this field
    const fieldToRemove = formValues[i];
    const referencedByFormulas = formValues.filter(f =>
      f.field_type === 'formula' &&
      f.referenced_field_ids?.includes(fieldToRemove.id)
    );

    if (referencedByFormulas.length > 0) {
      const fieldNames = referencedByFormulas.map(f => f.label).join(', ');
      const confirmed = window.confirm(
        `Warning: This field is referenced by formula field(s): ${fieldNames}\n\n` +
        `Removing it will break these formulas. Continue?`
      );
      if (!confirmed) {
        return;
      }
    }

    setRowIndex(rowIndex - 1);
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };
  let addRadioCheckboxFormFields = (index) => {
    radioAddFieldArr[index].push({ radioCheckboxValue: "" });
    setFormRadioCheckbox([...formRadioCheckbox, { radioCheckboxValue: "" }]);
  };
  let handleSubmit = async (event) => {
    event.preventDefault();

    // Validate required fields
    if (!formData.name) {
      toast.error("Form name is required.");
      return;
    }
    if (!formData.department_id) {
      toast.error("Department is required.");
      return;
    }
    if (!formData.category_id) {
      toast.error("Form category is required.");
      return;
    }

    // Validate all fields before submission
    const validationResult = validateAllFields(formValues);

    if (validationResult.hasErrors) {
      // Update the fieldErrors state with all validation errors
      setFieldErrors(validationResult.errors);

      // Show first error to user
      const firstFieldWithError = Object.keys(validationResult.errors)[0];
      const firstError = Object.values(validationResult.errors[firstFieldWithError])[0];
      toast.error(`Field ${parseInt(firstFieldWithError) + 1}: ${firstError}`);

      // Scroll to first field with error
      const firstErrorElement = document.querySelector(`[data-field-index="${firstFieldWithError}"]`);
      if (firstErrorElement) {
        firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      return;
    }

    // Check if there are any existing validation errors
    const hasValidationErrors = Object.keys(fieldErrors).length > 0;

    if (hasValidationErrors) {
      // Show first error to user
      const firstFieldWithError = Object.keys(fieldErrors)[0];
      const firstError = Object.values(fieldErrors[firstFieldWithError])[0];
      toast.error(`Field ${parseInt(firstFieldWithError) + 1}: ${firstError}`);
      return;
    }

    // Ensure at least one field exists
    if (formValues.length === 0) {
      toast.error("Form must have at least one field.");
      return;
    }

    // Set loading state to prevent duplicate submissions
    setIsLoading(true);

    // Function to filter validation messages based on field type and configuration
    const getRelevantValidationMessages = (field, fieldType) => {
      // Header fields should not have any validation
      if (fieldType === 'header') return null;

      if (!field.validation) return null;

      const validationMessages = {};

      // Always include required message if field is required
      if ((field.required || field.isMandatory === 1) && field.validation.required_message) {
        validationMessages.required_message = field.validation.required_message;
      }

      // Field type specific validation messages
      switch (fieldType) {
        case 'text':
        case 'textarea':
          if (field.min_length !== null && field.min_length !== undefined && field.validation.min_length_message) {
            validationMessages.min_length_message = field.validation.min_length_message;
          }
          if (field.max_length !== null && field.max_length !== undefined && field.validation.max_length_message) {
            validationMessages.max_length_message = field.validation.max_length_message;
          }
          if (field.validation.pattern && field.validation.pattern_message) {
            validationMessages.pattern = field.validation.pattern;
            validationMessages.pattern_message = field.validation.pattern_message;
          }
          break;

        case 'email':
          if (field.validation.invalid_email_message) {
            validationMessages.invalid_email_message = field.validation.invalid_email_message;
          }
          if (field.validation.pattern && field.validation.pattern_message) {
            validationMessages.pattern = field.validation.pattern;
            validationMessages.pattern_message = field.validation.pattern_message;
          }
          break;

        case 'phone':
          if (field.validation.invalid_phone_message) {
            validationMessages.invalid_phone_message = field.validation.invalid_phone_message;
          }
          if (field.validation.pattern && field.validation.pattern_message) {
            validationMessages.pattern = field.validation.pattern;
            validationMessages.pattern_message = field.validation.pattern_message;
          }
          break;

        case 'url':
          if (field.validation.invalid_url_message) {
            validationMessages.invalid_url_message = field.validation.invalid_url_message;
          }
          break;

        case 'number':
          if (field.min_value !== null && field.min_value !== undefined && field.validation.min_value_message) {
            validationMessages.min_value_message = field.validation.min_value_message;
          }
          if (field.max_value !== null && field.max_value !== undefined && field.validation.max_value_message) {
            validationMessages.max_value_message = field.validation.max_value_message;
          }
          if (field.validation.invalid_number_message) {
            validationMessages.invalid_number_message = field.validation.invalid_number_message;
          }
          if (field.validation.pattern && field.validation.pattern_message) {
            validationMessages.pattern = field.validation.pattern;
            validationMessages.pattern_message = field.validation.pattern_message;
          }
          break;

        case 'date':
          if (field.min_value !== null && field.min_value !== undefined && field.validation.min_date_message) {
            validationMessages.min_date_message = field.validation.min_date_message;
          }
          if (field.max_value !== null && field.max_value !== undefined && field.validation.max_date_message) {
            validationMessages.max_date_message = field.validation.max_date_message;
          }
          if (field.validation.invalid_date_message) {
            validationMessages.invalid_date_message = field.validation.invalid_date_message;
          }
          break;

        case 'time':
          if (field.min_value !== null && field.min_value !== undefined && field.validation.min_time_message) {
            validationMessages.min_time_message = field.validation.min_time_message;
          }
          if (field.max_value !== null && field.max_value !== undefined && field.validation.max_time_message) {
            validationMessages.max_time_message = field.validation.max_time_message;
          }
          if (field.validation.invalid_time_message) {
            validationMessages.invalid_time_message = field.validation.invalid_time_message;
          }
          break;

        case 'datetime':
          if (field.min_value !== null && field.min_value !== undefined && field.validation.min_datetime_message) {
            validationMessages.min_datetime_message = field.validation.min_datetime_message;
          }
          if (field.max_value !== null && field.max_value !== undefined && field.validation.max_datetime_message) {
            validationMessages.max_datetime_message = field.validation.max_datetime_message;
          }
          if (field.validation.invalid_datetime_message) {
            validationMessages.invalid_datetime_message = field.validation.invalid_datetime_message;
          }
          break;

        case 'file_upload':
        case 'file':
          if (field.validation.invalid_file_type_message) {
            validationMessages.invalid_file_type_message = field.validation.invalid_file_type_message;
          }
          if (field.validation.file_too_large_message) {
            validationMessages.file_too_large_message = field.validation.file_too_large_message;
          }
          if (field.validation.too_many_files_message) {
            validationMessages.too_many_files_message = field.validation.too_many_files_message;
          }
          break;

        case 'dropdown':
        case 'select_manual':
        case 'multiselect':
        case 'radio':
        case 'checkboxes':
        case 'checkbox':
          // Choice fields typically only need required message
          break;

        case 'lookup':
          if (field.validation.no_results_message) {
            validationMessages.no_results_message = field.validation.no_results_message;
          }
          break;

        case 'toggle':
          // Toggle only needs required message (already handled above)
          break;

        case 'signature':
          // Signature only needs required message (already handled above)
          break;

        case 'formula':
          if (field.validation.invalid_formula_message) {
            validationMessages.invalid_formula_message = field.validation.invalid_formula_message;
          }
          if (field.validation.missing_field_message) {
            validationMessages.missing_field_message = field.validation.missing_field_message;
          }
          if (field.validation.division_by_zero_message) {
            validationMessages.division_by_zero_message = field.validation.division_by_zero_message;
          }
          break;

        default:
          // For unknown field types, include pattern validation if present
          if (field.validation.pattern && field.validation.pattern_message) {
            validationMessages.pattern = field.validation.pattern;
            validationMessages.pattern_message = field.validation.pattern_message;
          }
          break;
      }

      // Return empty object if no validation messages are relevant (backend expects dictionary, not null)
      return Object.keys(validationMessages).length > 0 ? validationMessages : {};
    };

    try {
      // Prepare data in backend format
      let data = {
        name: formData.name,
        description: formData.description,
        department_id: formData.department_id || null,
        category_id: formData.category_id || null,
        folder_id: formData.folder_id || null,
        fields: formValues.map((field, index) => {
          // Handle options for choice fields
          let optionStrings = [];
          if (field.options && Array.isArray(field.options)) {
            optionStrings = field.options.map((option) => {
              if (typeof option === 'string') return option;
              if (option && typeof option === 'object') {
                return option.label || option.value || option.radioCheckboxValue || '';
              }
              return String(option);
            }).filter(Boolean);
          } else if (field.radioCheckbox && Array.isArray(field.radioCheckbox)) {
            // Legacy support
            optionStrings = field.radioCheckbox.filter(Boolean);
          }

          // Determine field type for options validation and payload
          const raw = (field.field_type || field.fieldtype || 'text').toString();
          const lower = raw.toLowerCase();
          const typeMap = {
            select: 'dropdown',
            selectmanual: 'select_manual',
            multiselect: 'checkboxes',
            checkbox: 'checkbox',
            file: 'file_upload',
            image: 'file_upload',
            calculated: 'text',
            section: 'header',
            'select_manual': 'select_manual',
            'select-manual': 'select_manual',
            'selectmanual': 'select_manual',
            'multi-select': 'checkboxes',
            'multi_select': 'checkboxes',
            'multiselect': 'checkboxes',
            'file_upload': 'file_upload',
            'file-upload': 'file_upload',
            'fileupload': 'file_upload',
            // Additional mappings for common variations
            'textinput': 'text',
            'text_input': 'text',
            'text-input': 'text',
            'textarea': 'textarea',
            'text_area': 'textarea',
            'text-area': 'textarea',
            'number': 'number',
            'email': 'email',
            'date': 'date',
            'time': 'time',
            'datetime': 'datetime',
            'date_time': 'datetime',
            'date-time': 'datetime',
            'dropdown': 'dropdown',
            'radio': 'radio',
            'checkboxes': 'checkboxes',
            'signature': 'signature',
            'header': 'header',
            'paragraph': 'paragraph',
            'phone': 'phone',
            'url': 'url',
            'formula': 'formula',
          };
          const mappedType = typeMap[lower] || raw;

          // Validate that the mapped type is a valid field type
          const validFieldTypes = [
            'text', 'textarea', 'number', 'email', 'date', 'time', 'datetime',
            'dropdown', 'select_manual', 'radio', 'checkbox', 'checkboxes', 'file_upload',
            'signature', 'header', 'markdown', 'paragraph', 'phone', 'url', 'lookup', 'toggle',
            'formula'
          ];

          // Final validated field type (single source of truth)
          const fieldType = validFieldTypes.includes(mappedType) ? mappedType : 'text';

          if (!validFieldTypes.includes(mappedType)) {
            console.warn(`Invalid field type "${raw}" mapped to "${mappedType}", defaulting to "text"`);
          }

          // Ensure options are provided for choice fields
          const choiceFieldTypes = ['dropdown', 'select_manual', 'radio', 'checkboxes'];
          if (choiceFieldTypes.includes(fieldType) && (!optionStrings || optionStrings.length === 0)) {
            console.warn(`Field "${field.label || field.fieldName}" of type "${fieldType}" requires options but none provided`);
            // Add a default option to prevent validation error
            optionStrings.push('Option 1');
          }

          // Debug logging for field processing
          console.log(`Processing field ${index}:`, {
            originalType: raw,
            mappedType: fieldType,
            label: field.label || field.fieldName,
            options: optionStrings,
            isChoiceField: choiceFieldTypes.includes(fieldType),
            isFormula: fieldType === 'formula',
            formulaData: fieldType === 'formula' ? {
              formula_expression: field.formula_expression,
              referenced_field_ids: field.referenced_field_ids,
              decimal_places: field.decimal_places,
              prefix: field.prefix,
              suffix: field.suffix,
              show_formula: field.show_formula
            } : null
          });

          return {
            label: field.label || field.fieldName || '',
            field_type: fieldType,  // Use the single calculated field type
            required: Boolean(field.required) || field.isMandatory === 1,
            placeholder: field.placeholder || null,
            help_text: field.help_text || field.description || '',
            options: optionStrings,
            min_length: field.min_length && field.min_length !== "" ? parseInt(field.min_length, 10) : null,
            max_length: field.max_length && field.max_length !== "" ? parseInt(field.max_length, 10) : null,
            min_value: field.min_value && field.min_value !== "" ? parseFloat(field.min_value) : null,
            max_value: field.max_value && field.max_value !== "" ? parseFloat(field.max_value) : null,
            step: field.step ?? null,
            order: index,
            // Formula-specific properties (only included if field_type is 'formula')
            ...(fieldType === 'formula' && {
              formula_expression: field.formula_expression || '',
              referenced_field_ids: field.referenced_field_ids || [],
              decimal_places: field.decimal_places ?? 2,
              prefix: field.prefix || '',
              suffix: field.suffix || '',
              show_formula: Boolean(field.show_formula),
              calculated_value: field.calculated_value ?? null,
            }),
            // Validation configuration
            // validation: field.validation ? {
            //   required_message: field.validation.required_message || 'This field is required',
            //   min_length_message: field.validation.min_length_message || 'Text is too short',
            //   max_length_message: field.validation.max_length_message || 'Text is too long',
            //   min_value_message: field.validation.min_value_message || 'Number is too small',
            //   max_value_message: field.validation.max_value_message || 'Number is too large',
            //   invalid_number_message: field.validation.invalid_number_message || 'Please enter a valid number',
            //   invalid_email_message: field.validation.invalid_email_message || 'Please enter a valid email address',
            //   invalid_phone_message: field.validation.invalid_phone_message || 'Please enter a valid phone number',
            //   invalid_url_message: field.validation.invalid_url_message || 'Please enter a valid URL',
            //   min_date_message: field.validation.min_date_message || 'Date is too early',
            //   max_date_message: field.validation.max_date_message || 'Date is too late',
            //   invalid_date_message: field.validation.invalid_date_message || 'Please enter a valid date',
            //   min_time_message: field.validation.min_time_message || 'Time is too early',
            //   max_time_message: field.validation.max_time_message || 'Time is too late',
            //   invalid_time_message: field.validation.invalid_time_message || 'Please enter a valid time',
            //   min_datetime_message: field.validation.min_datetime_message || 'Date and time is too early',
            //   max_datetime_message: field.validation.max_datetime_message || 'Date and time is too late',
            //   invalid_datetime_message: field.validation.invalid_datetime_message || 'Please enter a valid date and time',
            //   invalid_file_type_message: field.validation.invalid_file_type_message || 'File type not allowed',
            //   file_too_large_message: field.validation.file_too_large_message || 'File size exceeds limit',
            //   too_many_files_message: field.validation.too_many_files_message || 'Too many files selected',
            //   no_results_message: field.validation.no_results_message || 'No matching results found',
            //   pattern: field.validation.pattern || '',
            //   pattern_message: field.validation.pattern_message || 'Please enter a valid format'
            // } : null,
            validation: getRelevantValidationMessages(field, fieldType),
            // compatibility extras
            field_name: field.fieldName || null,
            is_mandatory: field.isMandatory || 0,
            is_add_more: field.isAddMore || 0,
            field_description: field.description || null,
            form_type: field.formType || null,
            dropdown_form_id: field.dropdown_form_id || null,
            dropdown_field_id: field.dropdown_field_id || null,
            master_data_table: field.master_data_table || null,
            master_data_column: field.master_data_column || null,
            selected_form_id: field.selected_form_id || null,
            selected_other_fields: field.selected_other_fields || [],
          };
        })
      };

      // Debug logging for final data
      console.log('Final form data being sent:', JSON.stringify(data, null, 2));

      let res;
      if (useModernAPI) {
        res = await saveWebFormAction(data);
      } else {
        // Fallback to legacy action
        const { saveWebFormAction: legacySaveWebFormAction } = await import(
          "../../Action/admin.action"
        );
        res = await legacySaveWebFormAction(data);
      }

      if (res.success) {
        toast.success(res.message || res.msg || "Form saved successfully");
        setTimeout(() => {
          navigate(`${config.baseUrl}webforms`);
        }, 2000);
      } else {
        // Handle validation errors or other error objects
        const errorMessage = res.message || res.msg || res.error || "Failed to save form";
        if (typeof errorMessage === 'string') {
          toast.error(errorMessage);
        } else if (Array.isArray(errorMessage)) {
          errorMessage.forEach(err => {
            if (typeof err === 'string') {
              toast.error(err);
            } else if (err && typeof err === 'object' && err.msg) {
              toast.error(err.msg);
            }
          });
        } else {
          toast.error("Failed to save form");
        }
        setIsLoading(false); // Re-enable button on error
      }
    } catch (error) {
      const status = error?.response?.status;
      if (status === 403) {
        toast.error(error?.response?.data?.detail || 'You do not have permission to create forms.');
        setIsLoading(false);
        return;
      }
      const errorMessage = error.message || error.msg || "Failed to save form";
      if (typeof errorMessage === 'string') {
        toast.error(errorMessage);
      } else {
        toast.error("Failed to save form");
      }
      setIsLoading(false); // Re-enable button on error
    }
  };
  return (
    <>
      <Dashboardheader />
      <div className="wrapper">
        <Sidebar />
        <div id="content">
          <Container fluid className="p-4">
            {/* Modern Header Section */}
            <Row>
              <Col lg={12} md={12} sm={12} className="mb-4">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h3 className="mb-1 text-dark fw-bold">Add New Form</h3>
                    <p className="text-muted mb-0">Create a new dynamic form for healthcare data collection</p>
                  </div>
                  <Link
                    to={`${config.baseUrl}webforms`}
                    className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
                  >
                    <BsArrowLeftCircleFill size={16} />
                    Back to Forms
                  </Link>
                </div>
              </Col>
            </Row>
            {/* Section 1 - Form Details */}
            <Row>
              <Col lg={12} md={12} sm={12} className="mb-4">
                <div className="card border-0 shadow-sm">
                  <div className="card-header bg-primary bg-opacity-10 border-0">
                    <h6 className="mb-0 fw-semibold text-dark d-flex align-items-center gap-2">
                      <BsFilePlusFill className="text-primary" size={20} />
                      Section 1 – Form Details
                    </h6>
                  </div>
                  <div className="card-body">
                    <Row className="g-3">
                      <Col lg={6} md={6} sm={12}>
                        <label className="form-label text-sm fw-medium text-dark">
                          Form Name <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={(e) => setForm({ ...formData, name: e.target.value })}
                          placeholder="Enter descriptive form name..."
                          aria-label="Form name"
                          required
                        />
                      </Col>

                      <Col lg={6} md={6} sm={12}>
                        <label className="form-label text-sm fw-medium text-dark">
                          Form Number
                        </label>
                        <input
                          className="form-control bg-light"
                          type="text"
                          readOnly
                          value={formNumber}
                          aria-label="Auto-generated form number"
                        />
                        <small className="text-muted">Auto-generated unique identifier</small>
                      </Col>

                      <Col lg={6} md={6} sm={12}>
                        <label className="form-label text-sm fw-medium text-dark">
                          Department <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select"
                          name="department_id"
                          value={formData.department_id}
                          onChange={handleChangeForm}
                          aria-label="Select department"
                          required
                        >
                          <option value="">Choose department...</option>
                          {Array.isArray(departmentList) ? departmentList.map((data) => {
                            const departmentId = data.department_id || data._id || data.id || data.name;
                            const departmentName = data.name || data.department_name || 'Unknown';
                            return (
                              <option key={departmentId} value={departmentId}>
                                {departmentName}
                              </option>
                            );
                          }) : null}
                        </select>
                      </Col>

                      <Col lg={6} md={6} sm={12}>
                        <label className="form-label text-sm fw-medium text-dark">
                          Folder
                        </label>
                        <select
                          className="form-select"
                          name="folder_id"
                          onChange={handleChangeForm}
                          aria-label="Select folder"
                        >
                          <option value="">Choose folder...</option>
                          {Array.isArray(folderList) ? folderList.map((folder) => (
                            <option key={folder.folder_id} value={folder.folder_id}>
                              {folder.name}
                            </option>
                          )) : null}
                        </select>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>

            {/* Section 2 - Settings */}
            <Row>
              <Col lg={12} md={12} sm={12} className="mb-4">
                <div className="card border-0 shadow-sm">
                  <div className="card-header bg-success bg-opacity-10 border-0">
                    <h6 className="mb-0 fw-semibold text-dark d-flex align-items-center gap-2">
                      <BsFilePlusFill className="text-success" size={20} />
                      Section 2 – Settings
                    </h6>
                  </div>
                  <div className="card-body">
                    <Row className="g-3">
                      <Col lg={6} md={6} sm={12}>
                        <label className="form-label text-sm fw-medium text-dark">
                          Form Category <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select"
                          name="category_id"
                          value={formData.category_id}
                          onChange={(e) => setForm({ ...formData, category_id: e.target.value })}
                          aria-label="Select form category"
                          required
                        >
                          <option value="">Choose category...</option>
                          {Array.isArray(formCategoryList) ? formCategoryList.map((data) => {
                            const categoryId = data.category_id || data.id || data.name;
                            const categoryName = data.name || data.category_name || 'Unknown';
                            return (
                              <option key={categoryId} value={categoryId}>{categoryName}</option>
                            );
                          }) : null}
                        </select>
                      </Col>

                      {/* Late Entry Access - Future feature implementation
                      <Col lg={3} md={3} sm={12}>
                        <label className="form-label text-sm fw-medium text-dark">
                          Late Entry Access
                        </label>
                        <div className="d-flex align-items-center gap-3 mt-2">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="isLateEntry"
                              value="0"
                              id="lateEntryNo"
                              onChange={handleChangeForm}
                              defaultChecked
                            />
                            <label className="form-check-label" htmlFor="lateEntryNo">
                              No
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="isLateEntry"
                              value="1"
                              id="lateEntryYes"
                              onChange={handleChangeForm}
                            />
                            <label className="form-check-label" htmlFor="lateEntryYes">
                              Yes
                            </label>
                          </div>
                        </div>
                      </Col>

                      {formData?.isLateEntry == 1 && (
                        <Col lg={3} md={3} sm={12}>
                          <label className="form-label text-sm fw-medium text-dark">
                            Late Entry Time (Hours)
                          </label>
                          <input
                            className="form-control"
                            type="number"
                            name="lateEntryTime"
                            onChange={handleChangeForm}
                            placeholder="24"
                            min="1"
                            max="168"
                            aria-label="Late entry time in hours"
                          />
                          <small className="text-muted">Maximum 7 days (168 hours)</small>
                        </Col>
                      )}
                      */}

                      <Col lg={3} md={3} sm={12}>
                        <label className="form-label text-sm fw-medium text-dark">
                          Call to Action
                        </label>
                        <div className="d-flex align-items-center gap-3 mt-2">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="isCallToAction"
                              value="0"
                              id="callToActionNo"
                              onChange={handleChangeForm}
                              defaultChecked
                            />
                            <label className="form-check-label" htmlFor="callToActionNo">
                              No
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="isCallToAction"
                              value="1"
                              id="callToActionYes"
                              onChange={handleChangeForm}
                            />
                            <label className="form-check-label" htmlFor="callToActionYes">
                              Yes
                            </label>
                          </div>
                        </div>
                      </Col>

                      {formData?.isCallToAction == 1 && (
                        <Col lg={3} md={3} sm={12}>
                          <label className="form-label text-sm fw-medium text-dark">
                            Action Form Number
                          </label>
                          <input
                            className="form-control font-monospace"
                            type="text"
                            name="callToActionLink"
                            placeholder="698815462"
                            onChange={handleChangeForm}
                            aria-label="Target form number for call to action"
                          />
                        </Col>
                      )}
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>

            {/* Section 3 - Web Form Fields */}
            <Row>
              <Col lg={12} md={12} sm={12} className="mb-4">
                <div className="card border-0 shadow-sm">
                  <div className="card-header bg-warning bg-opacity-10 border-0">
                    <h6 className="mb-0 fw-semibold text-dark d-flex align-items-center gap-2">
                      <BsFilePlusFill className="text-warning" size={20} />
                      Section 3 – Web Form Fields
                    </h6>
                  </div>
                  <div className="card-body">
                    <form onSubmit={handleSubmit}>
                      {/* Field Builder Header */}
                      <div className="d-none d-md-block mb-3">
                        <div className="row fw-medium text-muted small">
                          <div className="col-md-1">#</div>
                          <div className="col-md-2">Field Type</div>
                          <div className="col-md-3">Field Name</div>
                          <div className="col-md-2">Options</div>
                          <div className="col-md-1">Required</div>
                          <div className="col-md-1">Add More</div>
                          <div className="col-md-2">Actions</div>
                        </div>
                        <hr />
                      </div>

                      {/* Dynamic Fields */}
                      <DndContext
                        sensors={sensors}
                        collisionDetection={closestCenter}
                        onDragEnd={handleDragEnd}
                      >
                        <SortableContext
                          items={formValues.map(f => f.id)}
                          strategy={verticalListSortingStrategy}
                        >
                          {formValues.map((element, index) => {
                        const config = FIELD_CONFIG_MAP[element.field_type];
                        const currentFieldErrors = fieldErrors[index] || {};
                        const hasErrors = Object.keys(currentFieldErrors).length > 0;
                        const fieldId = element.id;

                        return (
                          <SortableFieldItem key={fieldId} id={fieldId}>
                            {(dragHandleProps) => (
                              <div data-field-index={index} className={`mb-4 p-3 border rounded-3 ${hasErrors ? 'border-danger bg-danger bg-opacity-10' : 'bg-light bg-opacity-50'}`}>
                                {/* Field Header */}
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                  <h6 className="mb-0 fw-semibold text-dark d-flex align-items-center gap-2">
                                    {/* Drag Handle */}
                                    <span
                                      {...dragHandleProps}
                                      style={{
                                        cursor: 'grab',
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '4px'
                                      }}
                                      title="Drag to reorder"
                                    >
                                      <MdDragIndicator size={20} className="text-secondary" />
                                    </span>
                                    <span className="badge bg-primary me-2">{index + 1}</span>
                                    Field Configuration
                                  </h6>
                              <div className="d-flex gap-2">
                                {index > 0 && (
                                  <button
                                    type="button"
                                    className="btn btn-outline-danger btn-sm"
                                    onClick={() => removeFormFields(index)}
                                    title="Remove field"
                                  >
                                    <BsFillTrash3Fill size={14} />
                                  </button>
                                )}
                                {index === formValues.length - 1 && (
                                  <button
                                    type="button"
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() => addFormFields()}
                                    title="Add new field"
                                  >
                                    <BsFilePlusFill size={14} />
                                  </button>
                                )}
                              </div>
                            </div>

                            {/* Error Display */}
                            {hasErrors && (
                              <div className="alert alert-danger alert-sm mb-3">
                                <small>
                                  <strong>Validation Errors:</strong>
                                  <ul className="mb-0 mt-1">
                                    {Object.entries(currentFieldErrors).map(([key, error]) => (
                                      <li key={key}>{error}</li>
                                    ))}
                                  </ul>
                                </small>
                              </div>
                            )}

                            {/* Basic Field Configuration */}
                            <div className="row mb-3">
                              {/* Field Type */}
                              <div className="col-md-4 mb-2">
                                <label className="form-label small fw-medium text-dark">Field Type <span className="text-danger">*</span></label>
                                <select
                                  name="field_type"
                                  className={`form-select ${currentFieldErrors.field_type ? 'is-invalid' : ''}`}
                                  value={element.fieldtypeId || ""}
                                  onChange={(e) => handleChange(index, e)}
                                >
                                  <option value="">Choose type...</option>
                                  {Array.isArray(formFieldTypeList) && formFieldTypeList.map((item) => (
                                    <option key={item.id} value={item.id}>{item.name}</option>
                                  ))}
                                </select>
                              </div>

                              {/* Field Label */}
                              <div className="col-md-4 mb-2">
                                <label className="form-label small fw-medium text-dark">Field Label <span className="text-danger">*</span></label>
                                <input
                                  type="text"
                                  className={`form-control ${currentFieldErrors.label ? 'is-invalid' : ''}`}
                                  name="label"
                                  value={element.label || ""}
                                  onChange={(e) => handleChange(index, e)}
                                  onBlur={(e) => handleLabelBlur(index, e)}
                                  placeholder="Enter field label..."
                                />
                              </div>

                              {/* Required Checkbox - Hidden for header fields */}
                              {(element.field_type !== 'header' && element.fieldtype !== 'header') && (
                                <div className="col-md-4 mb-2 d-flex align-items-end">
                                  <div className="form-check">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      name="required"
                                      id={`required_${index}`}
                                      checked={element.required || false}
                                      onChange={(e) => handleChange(index, e)}
                                    />
                                    <label className="form-check-label" htmlFor={`required_${index}`}>
                                      Required field
                                    </label>
                                    <small className="text-muted d-block">
                                      Check to configure validation messages
                                    </small>
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* Help Text */}
                            <div className="row mb-3">
                              <div className="col-12">
                                <label className="form-label small fw-medium text-dark">Help Text</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="help_text"
                                  value={element.help_text || ""}
                                  onChange={(e) => handleChange(index, e)}
                                  placeholder="Optional help text for users..."
                                />
                              </div>
                            </div>

                            {/* Field Type Specific Controls */}
                            {config && (
                              <div className="field-type-controls">
                                <h6 className="small fw-semibold text-muted mb-2">Field Type Settings</h6>

                                {/* Options Editor for Choice Fields */}
                                {config.needsOptions && (
                                  <div className="options-editor mb-3">
                                    {/* Master Data Configuration */}
                                    <Card className="mb-3">
                                      <Card.Header className="py-2">
                                        <Form.Check
                                          type="switch"
                                          id={`use-master-data-${index}`}
                                          label="Use Master Data"
                                          checked={element.useMasterData || false}
                                          onChange={(e) => toggleMasterData(e, index)}
                                        />
                                      </Card.Header>

                                      {element.useMasterData && (
                                        <Card.Body className="p-3">
                                          {/* Master Data Table Selection */}
                                          <Form.Group className="mb-3">
                                            <Form.Label className="small fw-medium">
                                              Master Data Table <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Select
                                              options={masterDataTables}
                                              value={masterDataTables.find(t => t.value === element.master_data_table)}
                                              onChange={(selected) => handleMasterTableChange(selected, index)}
                                              placeholder="Select master data table..."
                                              isClearable
                                              isSearchable
                                            />
                                            <Form.Text className="text-muted">
                                              Choose the master data table to populate options from
                                            </Form.Text>
                                          </Form.Group>

                                          {/* Master Data Column Selection */}
                                          {element.master_data_table && (
                                            <Form.Group className="mb-3">
                                              <Form.Label className="small fw-medium">
                                                Display Column <span className="text-danger">*</span>
                                              </Form.Label>
                                              <Select
                                                options={masterDataColumns[element.master_data_table] || []}
                                                value={masterDataColumns[element.master_data_table]?.find(
                                                  c => c.value === element.master_data_column
                                                )}
                                                onChange={(selected) => handleMasterColumnChange(selected, index)}
                                                placeholder="Select column to display..."
                                                isClearable
                                                isSearchable
                                              />
                                              <Form.Text className="text-muted">
                                                Choose which column values to show in the dropdown
                                              </Form.Text>
                                            </Form.Group>
                                          )}

                                          {/* Preview Options Button */}
                                          {element.master_data_table && element.master_data_column && (
                                            <Button
                                              variant="outline-primary"
                                              size="sm"
                                              onClick={() => previewMasterDataOptions(index)}
                                            >
                                              Preview Options ({element.masterDataPreviewCount || 0} items)
                                            </Button>
                                          )}
                                        </Card.Body>
                                      )}
                                    </Card>

                                    {/* Static Options Configuration - Only show if not using master data */}
                                    {!element.useMasterData && (
                                      <>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                          <label className="form-label small fw-medium text-dark mb-0">
                                            Options <span className="text-danger">*</span>
                                          </label>
                                          <button
                                            type="button"
                                            className="btn btn-outline-primary btn-sm"
                                            onClick={() => addOption(index)}
                                          >
                                            <BsFilePlusFill size={12} className="me-1" />Add Option
                                          </button>
                                        </div>
                                      </>
                                    )}

                                    {/* Options List - Only show if not using master data */}
                                    {!element.useMasterData && (
                                      <div>
                                    {element.options && element.options.length > 0 ? (
                                      <div className="options-list">
                                        {element.options.map((option, optionIndex) => (
                                          <div key={optionIndex} className="mb-3">
                                            <div className="d-flex align-items-center gap-2 p-2 border rounded">
                                              <span className="badge bg-secondary">{optionIndex + 1}</span>
                                              <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Option label..."
                                                value={option.label || ""}
                                                onChange={(e) => updateOption(index, optionIndex, 'label', e.target.value)}
                                              />
                                              <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Option value..."
                                                value={option.value || ""}
                                                onChange={(e) => updateOption(index, optionIndex, 'value', e.target.value)}
                                              />

                                              {/* Image upload button */}
                                              <label
                                                className={`btn btn-sm ${option.imageUrl ? 'btn-success' : 'btn-outline-secondary'}`}
                                                title="Add image option"
                                                style={{cursor: 'pointer', whiteSpace: 'nowrap'}}
                                              >
                                                📷
                                                <input
                                                  type="file"
                                                  accept="image/*"
                                                  hidden
                                                  onChange={(e) => {
                                                    if (e.target.files[0]) {
                                                      uploadOptionImage(e.target.files[0], index, optionIndex);
                                                    }
                                                  }}
                                                />
                                              </label>

                                              <div className="btn-group">
                                                <button
                                                  type="button"
                                                  className="btn btn-outline-secondary btn-sm"
                                                  onClick={() => moveOption(index, optionIndex, 'up')}
                                                  disabled={optionIndex === 0}
                                                  title="Move up"
                                                >
                                                  ↑
                                                </button>
                                                <button
                                                  type="button"
                                                  className="btn btn-outline-secondary btn-sm"
                                                  onClick={() => moveOption(index, optionIndex, 'down')}
                                                  disabled={optionIndex === element.options.length - 1}
                                                  title="Move down"
                                                >
                                                  ↓
                                                </button>
                                              </div>
                                              <button
                                                type="button"
                                                className="btn btn-outline-danger btn-sm"
                                                onClick={() => removeOption(index, optionIndex)}
                                                disabled={element.options.length <= 1}
                                                title="Remove option"
                                              >
                                                <BsFillTrash3Fill size={12} />
                                              </button>
                                            </div>

                                            {/* Image preview thumbnail */}
                                            {option.imageUrl && (
                                              <div className="mt-2 ms-5 d-flex align-items-center gap-2 p-2 bg-light border rounded">
                                                <img
                                                  src={option.imageUrl}
                                                  alt={option.label}
                                                  style={{
                                                    width: '60px',
                                                    height: '60px',
                                                    objectFit: 'cover',
                                                    borderRadius: '4px',
                                                    border: '1px solid #dee2e6'
                                                  }}
                                                />
                                                <span className="small text-muted flex-grow-1">Image attached</span>
                                                <button
                                                  type="button"
                                                  className="btn btn-sm btn-outline-danger"
                                                  onClick={() => removeOptionImage(index, optionIndex)}
                                                  title="Remove image"
                                                >
                                                  Remove Image
                                                </button>
                                              </div>
                                            )}
                                          </div>
                                        ))}
                                      </div>
                                    ) : (
                                      <div className="text-muted small text-center py-2 border rounded">
                                        No options added yet. Click "Add Option" to get started.
                                      </div>
                                    )}
                                    {currentFieldErrors.options && (
                                      <div className="text-danger small mt-1">{currentFieldErrors.options}</div>
                                    )}
                                      </div>
                                    )}
                                  </div>
                                )}

                                {/* Text Field Controls */}
                                {(element.field_type === 'text' || element.field_type === 'textarea') && (
                                  <div className="row mb-2">
                                    <div className="col-md-4">
                                      <label className="form-label small fw-medium text-dark">Placeholder</label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        name="placeholder"
                                        value={element.placeholder || ""}
                                        onChange={(e) => handleChange(index, e)}
                                        placeholder="Enter placeholder text..."
                                      />
                                    </div>
                                    <div className="col-md-4">
                                      <label className="form-label small fw-medium text-dark">Min Length</label>
                                      <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        name="min_length"
                                        value={element.min_length || ""}
                                        onChange={(e) => handleChange(index, e)}
                                        min="0"
                                      />
                                    </div>
                                    <div className="col-md-4">
                                      <label className="form-label small fw-medium text-dark">Max Length</label>
                                      <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        name="max_length"
                                        value={element.max_length || ""}
                                        onChange={(e) => handleChange(index, e)}
                                        min="1"
                                      />
                                    </div>
                                  </div>
                                )}

                                {/* Number Field Controls */}
                                {element.field_type === 'number' && (
                                  <div className="row mb-2">
                                    <div className="col-md-4">
                                      <label className="form-label small fw-medium text-dark">Min Value</label>
                                      <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        name="min_value"
                                        value={element.min_value || ""}
                                        onChange={(e) => handleChange(index, e)}
                                        step="any"
                                      />
                                    </div>
                                    <div className="col-md-4">
                                      <label className="form-label small fw-medium text-dark">Max Value</label>
                                      <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        name="max_value"
                                        value={element.max_value || ""}
                                        onChange={(e) => handleChange(index, e)}
                                        step="any"
                                      />
                                    </div>
                                    <div className="col-md-4">
                                      <label className="form-label small fw-medium text-dark">Step</label>
                                      <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        name="step"
                                        value={element.step || ""}
                                        onChange={(e) => handleChange(index, e)}
                                        step="any"
                                        placeholder="1"
                                      />
                                    </div>
                                  </div>
                                )}

                                {/* Markdown Field Controls */}
                                {element.field_type === 'markdown' && (
                                  <div className="row mb-3">
                                    <div className="col-12">
                                      <Form.Group className="mb-3">
                                        <Form.Label className="small fw-medium text-dark">
                                          Markdown Content
                                        </Form.Label>
                                        <Form.Control
                                          as="textarea"
                                          rows={10}
                                          name="label"
                                          value={element.label || ''}
                                          onChange={(e) => handleChange(index, e)}
                                          placeholder="# Heading&#10;&#10;Your **markdown** content here..."
                                          style={{ fontFamily: 'monospace', fontSize: '14px' }}
                                        />
                                        <Form.Text className="text-muted d-block mb-2">
                                          Supports: **bold**, *italic*, # headings, - lists, [links](url),
                                          tables, task lists, and more.
                                        </Form.Text>

                                        {/* Live Preview */}
                                        <div className="mt-3">
                                          <strong className="small fw-medium text-dark">Preview:</strong>
                                          <div
                                            className="border rounded p-3 mt-2 markdown-preview"
                                            style={{ backgroundColor: '#f8f9fa', minHeight: '100px' }}
                                          >
                                            <ReactMarkdown remarkPlugins={[remarkGfm]}>
                                              {element.label || '*No content*'}
                                            </ReactMarkdown>
                                          </div>
                                        </div>
                                      </Form.Group>
                                    </div>
                                  </div>
                                )}

                                {/* Formula Field Controls */}
                                {element.field_type === 'formula' && (
                                  <>
                                    {/* Formula Expression Builder */}
                                    <div className="row mb-3">
                                      <div className="col-12">
                                        <label className="form-label small fw-medium text-dark">
                                          Formula Expression <span className="text-danger">*</span>
                                        </label>

                                        {/* Field Picker Dropdown */}
                                        <div className="mb-2">
                                          <select
                                            className="form-select form-select-sm mb-2"
                                            onChange={(e) => {
                                              if (e.target.value) {
                                                insertFieldIntoFormula(index, e.target.value);
                                                e.target.value = "";
                                              }
                                            }}
                                          >
                                            <option value="">+ Insert Field</option>
                                            {formValues.map((field, idx) =>
                                              field.field_type === 'number' && idx !== index ? (
                                                <option key={field.id} value={field.id}>
                                                  {field.label} ({field.id})
                                                </option>
                                              ) : null
                                            )}
                                          </select>

                                          {/* Operator Buttons */}
                                          <div className="btn-group btn-group-sm mb-2" role="group">
                                            <button type="button" className="btn btn-outline-secondary"
                                                    onClick={() => insertOperatorIntoFormula(index, '+')}>+</button>
                                            <button type="button" className="btn btn-outline-secondary"
                                                    onClick={() => insertOperatorIntoFormula(index, '-')}>-</button>
                                            <button type="button" className="btn btn-outline-secondary"
                                                    onClick={() => insertOperatorIntoFormula(index, '*')}>×</button>
                                            <button type="button" className="btn btn-outline-secondary"
                                                    onClick={() => insertOperatorIntoFormula(index, '/')}>/</button>
                                            <button type="button" className="btn btn-outline-secondary"
                                                    onClick={() => insertOperatorIntoFormula(index, '^')}
                                                    title="Power/Exponent (e.g., x^2)">
                                              x<sup>y</sup>
                                            </button>
                                            <button type="button" className="btn btn-outline-secondary"
                                                    onClick={() => insertOperatorIntoFormula(index, '(')}>(</button>
                                            <button type="button" className="btn btn-outline-secondary"
                                                    onClick={() => insertOperatorIntoFormula(index, ')')}>)</button>
                                          </div>
                                        </div>

                                        {/* Formula Input */}
                                        <input
                                          type="text"
                                          className={`form-control form-control-sm ${element.formula_error ? 'is-invalid' : ''}`}
                                          name="formula_expression"
                                          value={element.formula_expression || ""}
                                          onChange={(e) => handleFormulaChange(index, e)}
                                          placeholder="e.g., weight / height ^ 2 (for BMI)"
                                        />

                                        {/* Error Display */}
                                        {element.formula_error && (
                                          <div className="invalid-feedback d-block">
                                            {element.formula_error}
                                          </div>
                                        )}

                                        {/* Referenced Fields Display */}
                                        {element.referenced_field_ids?.length > 0 && (
                                          <div className="mt-2">
                                            <small className="text-muted d-block">Referenced fields:</small>
                                            <div className="d-flex flex-wrap gap-1 mt-1">
                                              {element.referenced_field_ids.map(fieldId => {
                                                const refField = formValues.find(f => f.id === fieldId);
                                                return refField ? (
                                                  <span key={fieldId} className="badge bg-info">
                                                    {refField.label}
                                                  </span>
                                                ) : null;
                                              })}
                                            </div>
                                          </div>
                                        )}

                                        {/* Preview Calculation */}
                                        {element.calculated_value !== null && !element.formula_error && (
                                          <div className="mt-2">
                                            <small className="text-success d-block">
                                              Preview: {element.calculated_value}
                                            </small>
                                          </div>
                                        )}
                                      </div>
                                    </div>

                                    {/* Formatting Options */}
                                    <div className="row mb-2">
                                      <div className="col-md-4">
                                        <label className="form-label small fw-medium text-dark">Decimal Places</label>
                                        <input
                                          type="number"
                                          className="form-control form-control-sm"
                                          name="decimal_places"
                                          value={element.decimal_places ?? 2}
                                          onChange={(e) => handleChange(index, e)}
                                          min="0"
                                          max="10"
                                        />
                                      </div>

                                      <div className="col-md-4">
                                        <label className="form-label small fw-medium text-dark">Prefix</label>
                                        <input
                                          type="text"
                                          className="form-control form-control-sm"
                                          name="prefix"
                                          value={element.prefix || ""}
                                          onChange={(e) => handleChange(index, e)}
                                          placeholder="e.g., $"
                                          maxLength="10"
                                        />
                                      </div>

                                      <div className="col-md-4">
                                        <label className="form-label small fw-medium text-dark">Suffix</label>
                                        <input
                                          type="text"
                                          className="form-control form-control-sm"
                                          name="suffix"
                                          value={element.suffix || ""}
                                          onChange={(e) => handleChange(index, e)}
                                          placeholder="e.g., %"
                                          maxLength="10"
                                        />
                                      </div>
                                    </div>

                                    {/* Display Options */}
                                    <div className="row mb-2">
                                      <div className="col-12">
                                        <div className="form-check">
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="show_formula"
                                            checked={element.show_formula || false}
                                            onChange={(e) => handleChange(index, {
                                              target: { name: e.target.name, value: e.target.checked }
                                            })}
                                          />
                                          <label className="form-check-label">
                                            Show formula to users
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}

                                {/* Date/Time Field Controls */}
                                {(element.field_type === 'date' || element.field_type === 'time' || element.field_type === 'datetime') && (
                                  <div className="row mb-2">
                                    <div className="col-md-6">
                                      <label className="form-label small fw-medium text-dark">Min {element.field_type}</label>
                                      <input
                                        type={element.field_type}
                                        className="form-control form-control-sm"
                                        name="min_value"
                                        value={element.min_value || ""}
                                        onChange={(e) => handleChange(index, e)}
                                      />
                                    </div>
                                    <div className="col-md-6">
                                      <label className="form-label small fw-medium text-dark">Max {element.field_type}</label>
                                      <input
                                        type={element.field_type}
                                        className="form-control form-control-sm"
                                        name="max_value"
                                        value={element.max_value || ""}
                                        onChange={(e) => handleChange(index, e)}
                                      />
                                    </div>
                                  </div>
                                )}

                                {/* Radio/Checkbox Layout Controls */}
                                {(element.field_type === 'radio' || element.field_type === 'checkbox') && (
                                  <div className="row mb-2">
                                    <div className="col-md-6">
                                      <label className="form-label small fw-medium text-dark">Layout</label>
                                      <select
                                        className="form-select form-select-sm"
                                        name="layout"
                                        value={element.layout || 'column'}
                                        onChange={(e) => handleChange(index, e)}
                                      >
                                        <option value="column">Vertical (Column)</option>
                                        <option value="row">Horizontal (Row)</option>
                                      </select>
                                    </div>
                                  </div>
                                )}

                                {/* File Upload Controls */}
                                {element.field_type === 'file' && (
                                  <div className="row mb-2">
                                    <div className="col-md-4">
                                      <label className="form-label small fw-medium text-dark">Accept Types</label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        name="accept"
                                        value={element.accept || ""}
                                        onChange={(e) => handleChange(index, e)}
                                        placeholder="e.g., .pdf,.doc,.jpg"
                                      />
                                    </div>
                                    <div className="col-md-4">
                                      <label className="form-label small fw-medium text-dark">Max Size (MB)</label>
                                      <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        name="maxSize"
                                        value={element.maxSize || ""}
                                        onChange={(e) => handleChange(index, e)}
                                        min="1"
                                        max="100"
                                      />
                                    </div>
                                    <div className="col-md-4">
                                      <label className="form-label small fw-medium text-dark">Max Quantity</label>
                                      <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        name="maxQuantity"
                                        value={element.maxQuantity || ""}
                                        onChange={(e) => handleChange(index, e)}
                                        min="1"
                                        max="10"
                                      />
                                    </div>
                                  </div>
                                )}

                                {/* Validation Messages Configuration */}
                                {config && element.validation && element.required && (
                                  <div className="validation-messages mb-3 fade-in">
                                    <h6 className="small fw-semibold text-muted mb-2 d-flex align-items-center gap-2">
                                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-primary">
                                        <path d="M9 12l2 2 4-4"></path>
                                        <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"></path>
                                        <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"></path>
                                      </svg>
                                      Validation Messages
                                    </h6>
                                    <div className="border rounded p-3 bg-light bg-opacity-50" style={{ transition: 'all 0.3s ease-in-out' }}>

                                      {/* Required Message */}
                                      {config.controls.includes('required') && (
                                        <div className="row mb-2">
                                          <div className="col-12">
                                            <label className="form-label small fw-medium text-dark">Required Field Message</label>
                                            <input
                                              type="text"
                                              className="form-control form-control-sm"
                                              name="validation.required_message"
                                              value={element.validation?.required_message || ""}
                                              onChange={(e) => handleChange(index, e)}
                                              placeholder="This field is required"
                                            />
                                          </div>
                                        </div>
                                      )}

                                      {/* Text Length Messages */}
                                      {(element.field_type === 'text' || element.field_type === 'textarea') && (
                                        <>
                                          <div className="row mb-2">
                                            <div className="col-md-6">
                                              <label className="form-label small fw-medium text-dark">Min Length Message</label>
                                              <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="validation.min_length_message"
                                                value={element.validation?.min_length_message || ""}
                                                onChange={(e) => handleChange(index, e)}
                                                placeholder="Text is too short"
                                              />
                                            </div>
                                            <div className="col-md-6">
                                              <label className="form-label small fw-medium text-dark">Max Length Message</label>
                                              <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="validation.max_length_message"
                                                value={element.validation?.max_length_message || ""}
                                                onChange={(e) => handleChange(index, e)}
                                                placeholder="Text is too long"
                                              />
                                            </div>
                                          </div>

                                          {/* Pattern Validation for Text Fields */}
                                          <div className="row mb-2">
                                            <div className="col-md-6">
                                              <label className="form-label small fw-medium text-dark">Custom Pattern (RegEx)</label>
                                              <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="validation.pattern"
                                                value={element.validation?.pattern || ""}
                                                onChange={(e) => handleChange(index, e)}
                                                placeholder="^[A-Za-z0-9]+$"
                                              />
                                            </div>
                                            <div className="col-md-6">
                                              <label className="form-label small fw-medium text-dark">Pattern Message</label>
                                              <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="validation.pattern_message"
                                                value={element.validation?.pattern_message || ""}
                                                onChange={(e) => handleChange(index, e)}
                                                placeholder="Please enter a valid format"
                                              />
                                            </div>
                                          </div>
                                        </>
                                      )}

                                      {/* Number Validation Messages */}
                                      {element.field_type === 'number' && (
                                        <>
                                          <div className="row mb-2">
                                            <div className="col-md-4">
                                              <label className="form-label small fw-medium text-dark">Min Value Message</label>
                                              <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="validation.min_value_message"
                                                value={element.validation?.min_value_message || ""}
                                                onChange={(e) => handleChange(index, e)}
                                                placeholder="Number is too small"
                                              />
                                            </div>
                                            <div className="col-md-4">
                                              <label className="form-label small fw-medium text-dark">Max Value Message</label>
                                              <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="validation.max_value_message"
                                                value={element.validation?.max_value_message || ""}
                                                onChange={(e) => handleChange(index, e)}
                                                placeholder="Number is too large"
                                              />
                                            </div>
                                            <div className="col-md-4">
                                              <label className="form-label small fw-medium text-dark">Invalid Number Message</label>
                                              <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="validation.invalid_number_message"
                                                value={element.validation?.invalid_number_message || ""}
                                                onChange={(e) => handleChange(index, e)}
                                                placeholder="Please enter a valid number"
                                              />
                                            </div>
                                          </div>

                                          {/* Custom Pattern Validation for Number Fields */}
                                          <div className="row mb-2">
                                            <div className="col-md-6">
                                              <label className="form-label small fw-medium text-dark">Custom Pattern (RegEx)</label>
                                              <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="validation.pattern"
                                                value={element.validation?.pattern || ""}
                                                onChange={(e) => handleChange(index, e)}
                                                placeholder="^\d{1,10}(\.\d{1,2})?$"
                                              />
                                              <small className="text-muted">E.g., ^\d{"{1,10}"}(\.\d{"{1,2}"})? for decimal numbers</small>
                                            </div>
                                            <div className="col-md-6">
                                              <label className="form-label small fw-medium text-dark">Pattern Message</label>
                                              <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="validation.pattern_message"
                                                value={element.validation?.pattern_message || ""}
                                                onChange={(e) => handleChange(index, e)}
                                                placeholder="Please enter a valid number format"
                                              />
                                            </div>
                                          </div>
                                        </>
                                      )}

                                      {/* Email Validation Message */}
                                      {element.field_type === 'email' && (
                                        <div className="row mb-2">
                                          <div className="col-12">
                                            <label className="form-label small fw-medium text-dark">Invalid Email Message</label>
                                            <input
                                              type="text"
                                              className="form-control form-control-sm"
                                              name="validation.invalid_email_message"
                                              value={element.validation?.invalid_email_message || ""}
                                              onChange={(e) => handleChange(index, e)}
                                              placeholder="Please enter a valid email address"
                                            />
                                          </div>
                                        </div>
                                      )}

                                      {/* Phone Validation Message */}
                                      {element.field_type === 'phone' && (
                                        <>
                                          <div className="row mb-2">
                                            <div className="col-12">
                                              <label className="form-label small fw-medium text-dark">Invalid Phone Message</label>
                                              <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="validation.invalid_phone_message"
                                                value={element.validation?.invalid_phone_message || ""}
                                                onChange={(e) => handleChange(index, e)}
                                                placeholder="Please enter a valid phone number"
                                              />
                                            </div>
                                          </div>

                                          {/* Custom Pattern Validation for Phone Fields */}
                                          <div className="row mb-2">
                                            <div className="col-md-6">
                                              <label className="form-label small fw-medium text-dark">Custom Pattern (RegEx)</label>
                                              <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="validation.pattern"
                                                value={element.validation?.pattern || ""}
                                                onChange={(e) => handleChange(index, e)}
                                                placeholder="^\+?[1-9]\d{1,14}$"
                                              />
                                              <small className="text-muted">E.g., ^\+?[1-9]\d{"{1,14}"} for international format</small>
                                            </div>
                                            <div className="col-md-6">
                                              <label className="form-label small fw-medium text-dark">Pattern Message</label>
                                              <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="validation.pattern_message"
                                                value={element.validation?.pattern_message || ""}
                                                onChange={(e) => handleChange(index, e)}
                                                placeholder="Please enter a valid phone format"
                                              />
                                            </div>
                                          </div>
                                        </>
                                      )}

                                      {/* URL Validation Message */}
                                      {element.field_type === 'url' && (
                                        <div className="row mb-2">
                                          <div className="col-12">
                                            <label className="form-label small fw-medium text-dark">Invalid URL Message</label>
                                            <input
                                              type="text"
                                              className="form-control form-control-sm"
                                              name="validation.invalid_url_message"
                                              value={element.validation?.invalid_url_message || ""}
                                              onChange={(e) => handleChange(index, e)}
                                              placeholder="Please enter a valid URL"
                                            />
                                          </div>
                                        </div>
                                      )}

                                      {/* Date/Time Validation Messages */}
                                      {(element.field_type === 'date' || element.field_type === 'time' || element.field_type === 'datetime') && (
                                        <div className="row mb-2">
                                          <div className="col-md-4">
                                            <label className="form-label small fw-medium text-dark">Min {element.field_type} Message</label>
                                            <input
                                              type="text"
                                              className="form-control form-control-sm"
                                              name={`validation.min_${element.field_type}_message`}
                                              value={element.validation?.[`min_${element.field_type}_message`] || ""}
                                              onChange={(e) => handleChange(index, e)}
                                              placeholder={`${element.field_type} is too early`}
                                            />
                                          </div>
                                          <div className="col-md-4">
                                            <label className="form-label small fw-medium text-dark">Max {element.field_type} Message</label>
                                            <input
                                              type="text"
                                              className="form-control form-control-sm"
                                              name={`validation.max_${element.field_type}_message`}
                                              value={element.validation?.[`max_${element.field_type}_message`] || ""}
                                              onChange={(e) => handleChange(index, e)}
                                              placeholder={`${element.field_type} is too late`}
                                            />
                                          </div>
                                          <div className="col-md-4">
                                            <label className="form-label small fw-medium text-dark">Invalid {element.field_type} Message</label>
                                            <input
                                              type="text"
                                              className="form-control form-control-sm"
                                              name={`validation.invalid_${element.field_type}_message`}
                                              value={element.validation?.[`invalid_${element.field_type}_message`] || ""}
                                              onChange={(e) => handleChange(index, e)}
                                              placeholder={`Please enter a valid ${element.field_type}`}
                                            />
                                          </div>
                                        </div>
                                      )}

                                      {/* File Upload Validation Messages */}
                                      {element.field_type === 'file' && (
                                        <>
                                          {/* Required Message for File Upload */}
                                          <div className="row mb-2">
                                            <div className="col-12">
                                              <label className="form-label small fw-medium text-dark">Required File Message</label>
                                              <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="validation.required_message"
                                                value={element.validation?.required_message || ""}
                                                onChange={(e) => handleChange(index, e)}
                                                placeholder="Please select a file"
                                              />
                                            </div>
                                          </div>

                                          <div className="row mb-2">
                                            <div className="col-md-6">
                                              <label className="form-label small fw-medium text-dark">Invalid File Type Message</label>
                                              <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="validation.invalid_file_type_message"
                                                value={element.validation?.invalid_file_type_message || ""}
                                                onChange={(e) => handleChange(index, e)}
                                                placeholder="File type not allowed"
                                              />
                                            </div>
                                            <div className="col-md-6">
                                              <label className="form-label small fw-medium text-dark">File Too Large Message</label>
                                              <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="validation.file_too_large_message"
                                                value={element.validation?.file_too_large_message || ""}
                                                onChange={(e) => handleChange(index, e)}
                                                placeholder="File size exceeds limit"
                                              />
                                            </div>
                                          </div>
                                          <div className="row mb-2">
                                            <div className="col-12">
                                              <label className="form-label small fw-medium text-dark">Too Many Files Message</label>
                                              <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="validation.too_many_files_message"
                                                value={element.validation?.too_many_files_message || ""}
                                                onChange={(e) => handleChange(index, e)}
                                                placeholder="Too many files selected"
                                              />
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </SortableFieldItem>
                    );
                  })}
                        </SortableContext>
                      </DndContext>

                      {/* Action Buttons */}
                      <div className="d-flex justify-content-between align-items-center mt-4 pt-3 border-top">
                        <div>
                          <small className="text-muted">
                            Total fields: {formValues.length}
                            {Object.keys(fieldErrors).length > 0 && (
                              <span className="text-danger ms-2">
                                • {Object.keys(fieldErrors).length} field(s) with errors
                              </span>
                            )}
                          </small>
                        </div>
                        <div className="d-flex gap-2">
                          <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() => addFormFields()}
                          >
                            <BsFilePlusFill size={16} className="me-1" />
                            Add Field
                          </button>
                          <button
                            type="submit"
                            className={`btn btn-sm ${Object.keys(fieldErrors).length > 0
                              ? 'btn-outline-danger'
                              : 'btn-primary'
                              }`}
                            disabled={Object.keys(fieldErrors).length > 0 || isLoading}
                          >
                            <MdVisibility size={16} className="me-1" />
                            {isLoading ? 'Creating...' : 'Create Form'}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </Col>
            </Row>

            {/* Form Preview Section */}
            {formValues.length > 0 && formValues.some(field => field.label) && (
              <Row>
                <Col lg={12} md={12} sm={12} className="mb-4">
                  <div className="card border-0 shadow-sm">
                    <div className="card-header bg-info bg-opacity-10 border-0">
                      <h6 className="mb-0 fw-semibold text-dark d-flex align-items-center gap-2">
                        <MdVisibility className="text-info" size={20} />
                        Form Preview
                      </h6>
                    </div>
                    <div className="card-body">
                      <div className='formDiv'>
                        <Form>
                          <Row className="mb-4">
                            {formValues.map((field, fieldIndex) => {
                              if (!field.label && !field.fieldName) return null;

                              // Get options from multiple possible sources and filter out invalid ones
                              const getFieldOptions = (field) => {
                                let rawOptions = [];

                                // Gather options from various sources
                                if (field.options && Array.isArray(field.options)) {
                                  rawOptions = field.options;
                                } else if (field.radioCheckbox) {
                                  if (Array.isArray(field.radioCheckbox)) {
                                    rawOptions = field.radioCheckbox;
                                  } else if (typeof field.radioCheckbox === 'string') {
                                    try {
                                      rawOptions = JSON.parse(field.radioCheckbox);
                                    } catch (e) {
                                      rawOptions = [];
                                    }
                                  }
                                } else if (field.radioCheckboxValue) {
                                  try {
                                    rawOptions = JSON.parse(field.radioCheckboxValue);
                                  } catch (e) {
                                    rawOptions = [];
                                  }
                                }

                                // Filter and validate options
                                if (!Array.isArray(rawOptions)) {
                                  return [];
                                }

                                return rawOptions.filter(option => {
                                  // Remove null, undefined, or completely empty options
                                  if (option === null || option === undefined) {
                                    return false;
                                  }

                                  // Handle string options
                                  if (typeof option === 'string') {
                                    return option.trim().length > 0;
                                  }

                                  // Handle object options
                                  if (typeof option === 'object' && option !== null) {
                                    // Must have at least a label or value that's not empty
                                    const hasLabel = option.label && typeof option.label === 'string' && option.label.trim().length > 0;
                                    const hasValue = option.value && typeof option.value === 'string' && option.value.trim().length > 0;
                                    const hasRadioCheckboxValue = option.radioCheckboxValue && typeof option.radioCheckboxValue === 'string' && option.radioCheckboxValue.trim().length > 0;

                                    return hasLabel || hasValue || hasRadioCheckboxValue;
                                  }

                                  return false;
                                }).map(option => {
                                  // Normalize options to ensure they have proper structure
                                  if (typeof option === 'string') {
                                    return {
                                      label: option,
                                      value: option
                                    };
                                  }

                                  if (typeof option === 'object' && option !== null) {
                                    return {
                                      label: option.label || option.value || option.radioCheckboxValue || 'Option',
                                      value: option.value || option.label || option.radioCheckboxValue || 'option'
                                    };
                                  }

                                  return {
                                    label: 'Option',
                                    value: 'option'
                                  };
                                });
                              };

                              const fieldOptions = getFieldOptions(field);

                              return (
                                <div key={field.id || fieldIndex} className='col-md-6 mt-2'>
                                  <Form.Group>
                                    <Form.Label>
                                      {field.label || field.fieldName}
                                      {(field.required || field.isMandatory) && <span className="text-danger ms-1">*</span>}
                                    </Form.Label>

                                    {/* Dropdown/Select fields */}
                                    {(field.field_type === "dropdown" || field.fieldtype === "dropdown" ||
                                      field.field_type === "select" || field.fieldtype === "select" ||
                                      field.field_type === "select_manual" || field.fieldtype === "select_manual" ||
                                      field.field_type === "selectManual" || field.fieldtype === "selectManual") ? (
                                      <>
                                        <select className="form-select" disabled>
                                          <option>Choose option...</option>
                                          {fieldOptions.map((option, optionIndex) => {
                                            // Safely extract option text
                                            const optionText = typeof option === 'string' ? option :
                                              (typeof option === 'object' && option !== null) ?
                                                (option.label || option.value || 'Option') : 'Option';
                                            const optionValue = typeof option === 'string' ? option :
                                              (typeof option === 'object' && option !== null) ?
                                                (option.value || option.label || 'option') : 'option';

                                            return (
                                              <option key={optionIndex} value={optionValue}>
                                                {String(optionText)}
                                              </option>
                                            );
                                          })}
                                        </select>
                                        {/* Show validation preview for required dropdown */}
                                        {field.required && field.validation?.required_message && (
                                          <div className="validation-preview mt-1">
                                            <small className="text-danger d-block">
                                              <strong>Validation:</strong> {field.validation.required_message}
                                            </small>
                                          </div>
                                        )}
                                      </>

                                    ) : /* Multi-select fields */
                                      (field.field_type === "multiselect" || field.fieldtype === "multiselect") ? (
                                        <select className="form-select" multiple disabled>
                                          {fieldOptions.map((option, optionIndex) => {
                                            // Safely extract option text
                                            const optionText = typeof option === 'string' ? option :
                                              (typeof option === 'object' && option !== null) ?
                                                (option.label || option.value || 'Option') : 'Option';
                                            const optionValue = typeof option === 'string' ? option :
                                              (typeof option === 'object' && option !== null) ?
                                                (option.value || option.label || 'option') : 'option';

                                            return (
                                              <option key={optionIndex} value={optionValue}>
                                                {String(optionText)}
                                              </option>
                                            );
                                          })}
                                        </select>

                                      ) : /* Textarea fields */
                                        (field.field_type === "textarea" || field.fieldtype === "textarea") ? (
                                          <>
                                            <textarea
                                              className="form-control"
                                              rows={field.rows || 3}
                                              placeholder={field.placeholder || "Enter text..."}
                                              disabled
                                              minLength={field.min_length}
                                              maxLength={field.max_length}
                                            />
                                            {/* Show validation preview for required textarea */}
                                            {field.required && field.validation?.required_message && (
                                              <div className="validation-preview mt-1">
                                                <small className="text-danger d-block">
                                                  <strong>Validation:</strong> {field.validation.required_message}
                                                </small>
                                              </div>
                                            )}
                                            {/* Show text length validation */}
                                            {(field.min_length || field.max_length) && (
                                              <div className="input-validation-preview mt-1">
                                                <small className="text-info d-block">
                                                  <strong>Length:</strong>
                                                  {field.min_length && ` Min ${field.min_length} chars`}
                                                  {field.min_length && field.max_length && `,`}
                                                  {field.max_length && ` Max ${field.max_length} chars`}
                                                </small>
                                                {field.validation?.min_length_message && field.min_length && (
                                                  <small className="text-danger d-block">
                                                    <strong>Min Length:</strong> {field.validation.min_length_message}
                                                  </small>
                                                )}
                                                {field.validation?.max_length_message && field.max_length && (
                                                  <small className="text-danger d-block">
                                                    <strong>Max Length:</strong> {field.validation.max_length_message}
                                                  </small>
                                                )}
                                              </div>
                                            )}
                                            {/* Show pattern validation */}
                                            {field.validation?.pattern && (
                                              <div className="pattern-preview mt-1">
                                                <small className="text-warning d-block">
                                                  <strong>Pattern:</strong> {field.validation.pattern}
                                                </small>
                                                {field.validation?.pattern_message && (
                                                  <small className="text-danger d-block">
                                                    <strong>Pattern Validation:</strong> {field.validation.pattern_message}
                                                  </small>
                                                )}
                                              </div>
                                            )}
                                          </>

                                        ) : /* Paragraph fields */
                                        (field.field_type === "paragraph" || field.fieldtype === "paragraph") ? (
                                          <>
                                            <textarea
                                              className="form-control"
                                              rows={field.rows || 5}
                                              placeholder={field.placeholder || "Enter text..."}
                                              disabled
                                              minLength={field.min_length}
                                              maxLength={field.max_length}
                                            />
                                            {/* Show validation preview for required paragraph */}
                                            {field.required && field.validation?.required_message && (
                                              <div className="validation-preview mt-1">
                                                <small className="text-danger d-block">
                                                  <strong>Validation:</strong> {field.validation.required_message}
                                                </small>
                                              </div>
                                            )}
                                            {/* Show text length validation */}
                                            {(field.min_length || field.max_length) && (
                                              <div className="input-validation-preview mt-1">
                                                <small className="text-info d-block">
                                                  <strong>Length:</strong>
                                                  {field.min_length && ` Min ${field.min_length} chars`}
                                                  {field.min_length && field.max_length && `,`}
                                                  {field.max_length && ` Max ${field.max_length} chars`}
                                                </small>
                                                {field.validation?.min_length_message && field.min_length && (
                                                  <small className="text-danger d-block">
                                                    <strong>Min Length:</strong> {field.validation.min_length_message}
                                                  </small>
                                                )}
                                                {field.validation?.max_length_message && field.max_length && (
                                                  <small className="text-danger d-block">
                                                    <strong>Max Length:</strong> {field.validation.max_length_message}
                                                  </small>
                                                )}
                                              </div>
                                            )}
                                            {/* Show pattern validation */}
                                            {field.validation?.pattern && (
                                              <div className="pattern-preview mt-1">
                                                <small className="text-warning d-block">
                                                  <strong>Pattern:</strong> {field.validation.pattern}
                                                </small>
                                                {field.validation?.pattern_message && (
                                                  <small className="text-danger d-block">
                                                    <strong>Pattern Validation:</strong> {field.validation.pattern_message}
                                                  </small>
                                                )}
                                              </div>
                                            )}
                                          </>

                                        ) : /* File upload fields */
                                          (field.field_type === "file" || field.fieldtype === "file" ||
                                            field.field_type === "file_upload" || field.fieldtype === "file_upload" ||
                                            field.field_type === "image" || field.fieldtype === "image") ? (
                                            <>
                                              <input
                                                type="file"
                                                className="form-control"
                                                accept={field.accept || "*/*"}
                                                disabled
                                              />
                                              {/* Show validation preview for required file upload fields */}
                                              {field.required && field.validation?.required_message && (
                                                <div className="validation-preview mt-1">
                                                  <small className="text-danger d-block">
                                                    <strong>Validation:</strong> {field.validation.required_message}
                                                  </small>
                                                </div>
                                              )}
                                            </>

                                          ) : /* Radio button fields */
                                            (field.field_type === "radio" || field.fieldtype === "radio") && fieldOptions.length > 0 ? (
                                              <div className={`mt-2 ${field.layout === 'row' ? 'd-flex gap-3' : ''}`}>
                                                {fieldOptions.map((option, optionIndex) => {
                                                  // Normalize option to object format if it's a string
                                                  const optionData = typeof option === 'string'
                                                    ? { label: option, value: option, imageUrl: null }
                                                    : option;

                                                  return (
                                                    <div key={optionIndex} className="form-check">
                                                      <input
                                                        type="radio"
                                                        className="form-check-input"
                                                        name={`radio-preview-${fieldIndex}`}
                                                        disabled
                                                      />
                                                      <label className="form-check-label d-flex align-items-start gap-2">
                                                        <span>{String(optionData.label || 'Option')}</span>
                                                        {optionData.imageUrl && (
                                                          <ImageOptionPreview
                                                            imageUrl={optionData.imageUrl}
                                                            label={optionData.label}
                                                          />
                                                        )}
                                                      </label>
                                                    </div>
                                                  );
                                                })}
                                              </div>

                                            ) : /* Checkbox fields - Multiple checkboxes like radio */
                                              (field.field_type === "checkbox" || field.fieldtype === "checkbox") ? (
                                                fieldOptions.length > 0 ? (
                                                  <div className={`mt-2 ${field.layout === 'row' ? 'd-flex gap-3' : ''}`}>
                                                    {fieldOptions.map((option, optionIndex) => {
                                                      // Normalize option to object format if it's a string
                                                      const optionData = typeof option === 'string'
                                                        ? { label: option, value: option, imageUrl: null }
                                                        : option;

                                                      return (
                                                        <div key={optionIndex} className="form-check">
                                                          <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            disabled
                                                          />
                                                          <label className="form-check-label d-flex align-items-start gap-2">
                                                            <span>{String(optionData.label || 'Option')}</span>
                                                            {optionData.imageUrl && (
                                                              <ImageOptionPreview
                                                                imageUrl={optionData.imageUrl}
                                                                label={optionData.label}
                                                              />
                                                            )}
                                                          </label>
                                                        </div>
                                                      );
                                                    })}
                                                  </div>
                                                ) : (
                                                  <div className="form-check">
                                                    <input
                                                      type="checkbox"
                                                      className="form-check-input"
                                                      disabled
                                                    />
                                                    <label className="form-check-label">Checkbox option (configure options above)</label>
                                                  </div>
                                                )
                                              ) : /* Checkboxes fields - Multiple checkboxes */
                                                (field.field_type === "checkboxes" || field.fieldtype === "checkboxes") ? (
                                                  fieldOptions.length > 0 ? (
                                                    <div className={`mt-2 ${field.layout === 'row' ? 'd-flex gap-3' : ''}`}>
                                                      {fieldOptions.map((option, optionIndex) => {
                                                        // Normalize option to object format if it's a string
                                                        const optionData = typeof option === 'string'
                                                          ? { label: option, value: option, imageUrl: null }
                                                          : option;

                                                        return (
                                                          <div key={optionIndex} className="form-check">
                                                            <input
                                                              type="checkbox"
                                                              className="form-check-input"
                                                              disabled
                                                            />
                                                            <label className="form-check-label d-flex align-items-start gap-2">
                                                              <span>{String(optionData.label || 'Option')}</span>
                                                              {optionData.imageUrl && (
                                                                <ImageOptionPreview
                                                                  imageUrl={optionData.imageUrl}
                                                                  label={optionData.label}
                                                                />
                                                              )}
                                                            </label>
                                                          </div>
                                                        );
                                                      })}
                                                    </div>
                                                  ) : (
                                                    <div className="form-check">
                                                      <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        disabled
                                                      />
                                                      <label className="form-check-label">Multiple checkbox option (configure options above)</label>
                                                    </div>
                                                  )
                                                ) : /* Toggle/Switch fields */
                                                  (field.field_type === "toggle" || field.fieldtype === "toggle") ? (
                                                    <div className="form-check form-switch">
                                                      <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        disabled
                                                      />
                                                      <label className="form-check-label">
                                                        {field.labelOn || 'Yes'} / {field.labelOff || 'No'}
                                                      </label>
                                                    </div>

                                                  ) : /* Header fields */
                                                    (field.field_type === "header" || field.fieldtype === "header") ? (
                                                      <div className="header-preview-container">
                                                        <div className="border-bottom pb-2 mb-2">
                                                          <h4 className="text-primary mb-0">
                                                            {field.label || field.fieldName || "Section Header"}
                                                          </h4>
                                                          {field.help_text && (
                                                            <small className="text-muted d-block mt-1">{field.help_text}</small>
                                                          )}
                                                        </div>
                                                      </div>
                                                    ) : /* Formula field preview rendering */
                                                    (field.field_type === "formula" || field.fieldtype === "formula") ? (
                                                      <div className="formula-preview-container">
                                                        <div className="input-group">
                                                          {field.prefix && (
                                                            <span className="input-group-text">{field.prefix}</span>
                                                          )}
                                                          <Form.Control
                                                            type="text"
                                                            value={field.calculated_value || '0.00'}
                                                            readOnly
                                                            disabled
                                                            className="bg-light"
                                                          />
                                                          {field.suffix && (
                                                            <span className="input-group-text">{field.suffix}</span>
                                                          )}
                                                        </div>

                                                        {field.show_formula && field.formula_expression && (
                                                          <Form.Text className="text-muted font-monospace d-block mt-1">
                                                            Formula: {field.formula_expression}
                                                          </Form.Text>
                                                        )}

                                                        {field.help_text && (
                                                          <Form.Text className="text-muted d-block mt-1">
                                                            {field.help_text}
                                                          </Form.Text>
                                                        )}

                                                        <div className="input-type-preview mt-1">
                                                          <small className="text-info d-block">
                                                            <strong>Field Type:</strong> Calculated field (read-only)
                                                          </small>
                                                          {field.formula_error && (
                                                            <small className="text-danger d-block">
                                                              <strong>Error:</strong> {field.formula_error}
                                                            </small>
                                                          )}
                                                        </div>
                                                      </div>

                                                    ) : /* Signature fields */
                                                    (field.field_type === "signature" || field.fieldtype === "signature") ? (
                                                      <div className="signature-preview-container">
                                                        <div className="border rounded p-3 bg-light text-center" style={{ minHeight: '120px', border: '2px dashed #dee2e6' }}>
                                                          <div className="d-flex flex-column justify-content-center align-items-center h-100">
                                                            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-muted mb-2">
                                                              <path d="M12 19l7-7 3 3-7 7-3-3z" />
                                                              <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" />
                                                              <path d="M2 2l7.586 7.586" />
                                                              <circle cx="11" cy="11" r="2" />
                                                            </svg>
                                                            <small className="text-muted">Signature pad</small>
                                                            <small className="text-muted">Click here to sign</small>
                                                          </div>
                                                        </div>
                                                        {/* Show validation preview for required signature */}
                                                        {field.required && field.validation?.required_message && (
                                                          <div className="validation-preview mt-1">
                                                            <small className="text-danger d-block">
                                                              <strong>Validation:</strong> {field.validation.required_message}
                                                            </small>
                                                          </div>
                                                        )}
                                                      </div>

                                                    ) : /* Default input fields */
                                                      (
                                                        <>
                                                          <Form.Control
                                                            type={field.field_type === "email" || field.fieldtype === "email" ? "email" :
                                                              field.field_type === "number" || field.fieldtype === "number" ? "number" :
                                                                field.field_type === "date" || field.fieldtype === "date" ? "date" :
                                                                  field.field_type === "time" || field.fieldtype === "time" ? "time" :
                                                                    field.field_type === "datetime" || field.fieldtype === "datetime" ? "datetime-local" :
                                                                      field.field_type === "phone" || field.fieldtype === "phone" ? "tel" :
                                                                        field.field_type === "url" || field.fieldtype === "url" ? "url" : "text"}
                                                            placeholder={field.placeholder || `Enter ${(field.label || field.fieldName).toLowerCase()}...`}
                                                            disabled
                                                            min={field.min_value}
                                                            max={field.max_value}
                                                            step={field.step}
                                                            minLength={field.min_length}
                                                            maxLength={field.max_length}
                                                            pattern={field.validation?.pattern || undefined}
                                                            title={field.validation?.pattern ? field.validation?.pattern_message : undefined}
                                                          />
                                                          {/* Show validation preview for required fields */}
                                                          {field.required && field.validation?.required_message && (
                                                            <div className="validation-preview mt-1">
                                                              <small className="text-danger d-block">
                                                                <strong>Validation:</strong> {field.validation.required_message}
                                                              </small>
                                                            </div>
                                                          )}
                                                          {/* Show number input enforcement message */}
                                                          {(field.field_type === "number" || field.fieldtype === "number") && (
                                                            <div className="input-type-preview mt-1">
                                                              <small className="text-info d-block">
                                                                <strong>Input Type:</strong> Only numbers allowed
                                                                {field.min_value && ` (min: ${field.min_value})`}
                                                                {field.max_value && ` (max: ${field.max_value})`}
                                                                {field.step && ` (step: ${field.step})`}
                                                              </small>
                                                              {field.validation?.invalid_number_message && (
                                                                <small className="text-danger d-block">
                                                                  <strong>Validation:</strong> {field.validation.invalid_number_message}
                                                                </small>
                                                              )}
                                                            </div>
                                                          )}
                                                          {/* Show email input enforcement message */}
                                                          {(field.field_type === "email" || field.fieldtype === "email") && (
                                                            <div className="input-type-preview mt-1">
                                                              <small className="text-info d-block">
                                                                <strong>Input Type:</strong> Email format enforced
                                                              </small>
                                                              {field.validation?.invalid_email_message && (
                                                                <small className="text-danger d-block">
                                                                  <strong>Validation:</strong> {field.validation.invalid_email_message}
                                                                </small>
                                                              )}
                                                            </div>
                                                          )}
                                                          {/* Show phone input enforcement message */}
                                                          {(field.field_type === "phone" || field.fieldtype === "phone") && (
                                                            <div className="input-type-preview mt-1">
                                                              <small className="text-info d-block">
                                                                <strong>Input Type:</strong> Phone number format
                                                              </small>
                                                              {field.validation?.invalid_phone_message && (
                                                                <small className="text-danger d-block">
                                                                  <strong>Validation:</strong> {field.validation.invalid_phone_message}
                                                                </small>
                                                              )}
                                                            </div>
                                                          )}
                                                          {/* Show URL input enforcement message */}
                                                          {(field.field_type === "url" || field.fieldtype === "url") && (
                                                            <div className="input-type-preview mt-1">
                                                              <small className="text-info d-block">
                                                                <strong>Input Type:</strong> URL format enforced
                                                              </small>
                                                              {field.validation?.invalid_url_message && (
                                                                <small className="text-danger d-block">
                                                                  <strong>Validation:</strong> {field.validation.invalid_url_message}
                                                                </small>
                                                              )}
                                                            </div>
                                                          )}
                                                          {/* Show text length validation */}
                                                          {(field.field_type === 'text' || field.field_type === 'textarea' || field.fieldtype === 'text' || field.fieldtype === 'textarea') &&
                                                            (field.min_length || field.max_length) && (
                                                              <div className="input-validation-preview mt-1">
                                                                <small className="text-info d-block">
                                                                  <strong>Length:</strong>
                                                                  {field.min_length && ` Min ${field.min_length} chars`}
                                                                  {field.min_length && field.max_length && ','}
                                                                  {field.max_length && ` Max ${field.max_length} chars`}
                                                                </small>
                                                              </div>
                                                            )}
                                                          {/* Show pattern validation */}
                                                          {field.validation?.pattern &&
                                                            (field.field_type === 'text' || field.field_type === 'textarea' ||
                                                              field.field_type === 'number' || field.field_type === 'phone' ||
                                                              field.fieldtype === 'text' || field.fieldtype === 'textarea' ||
                                                              field.fieldtype === 'number' || field.fieldtype === 'phone') && (
                                                              <div className="pattern-preview mt-1">
                                                                <small className="text-warning d-block">
                                                                  <strong>Pattern:</strong> {field.validation.pattern}
                                                                </small>
                                                                {field.validation?.pattern_message && (
                                                                  <small className="text-danger d-block">
                                                                    <strong>Validation:</strong> {field.validation.pattern_message}
                                                                  </small>
                                                                )}
                                                              </div>
                                                            )}
                                                        </>
                                                      )}

                                    {/* Help text */}
                                    {field.help_text && (
                                      <Form.Text className="text-muted">{field.help_text}</Form.Text>
                                    )}

                                    {/* Character count for text fields */}
                                    {(field.field_type === 'text' || field.field_type === 'textarea') &&
                                      field.max_length && (
                                        <Form.Text className="text-muted">
                                          Max {field.max_length} characters
                                        </Form.Text>
                                      )}
                                  </Form.Group>
                                </div>
                              );
                            })}

                            {formValues.length === 0 && (
                              <div className="col-12 text-center text-muted py-4">
                                <p>No fields to preview. Add some fields to see the preview.</p>
                              </div>
                            )}
                          </Row>
                        </Form>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            )}
          </Container>
        </div>
      </div>

      {/* Master Data Preview Modal */}
      <MasterDataPreviewModal
        show={previewModalData.visible}
        onHide={() => setPreviewModalData({ ...previewModalData, visible: false })}
        fieldLabel={previewModalData.fieldLabel}
        options={previewModalData.options}
        tableName={previewModalData.tableName}
        columnName={previewModalData.columnName}
      />
    </>
  );
};

export default Webform;
